<template>
  <svg
    id="milestone-book"
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="370"
    height="420"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 288 326.9"
    role="presentation"
    aria-labelledby="bookoreilly"
  >
    <title id="bookoreilly">Jamstack O'Reilly book published</title>
    <path class="cls-1" d="M237.7,226.9l-.8-.4-12.6,7.3.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M239.2,227.8l-.7-.4-12.7,7.2.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M240.8,228.6l-.8-.4-12.6,7.3.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M242.1,229.6l-.6-.5-12.6,7.3.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M242.7,231a1.9,1.9,0,0,0-.2-.7l-12.1,7,.7.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M242.5,232.8a2.9,2.9,0,0,0,.3-1L232,238l.7.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M218.5,216.3l-12.3,7.1.5.3,12.4-7.1Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M220.6,217.4l-.7-.4-12.4,7.2.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M222.2,218.3l-.7-.4L209,225.1l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M223.7,219.2l-.7-.4-12.4,7.1.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M225.3,220l-.7-.4-12.5,7.2.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M226.8,220.9l-.7-.4-12.5,7.2.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M228.4,221.8l-.7-.4-12.5,7.2.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M229.9,222.6l-.7-.4-12.5,7.2.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M231.5,223.5l-.8-.4-12.5,7.2.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M233,224.3l-.7-.4-12.6,7.3.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M234.6,225.2l-.8-.4L221.3,232l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M235.4,225.6l-12.6,7.3.7.4,12.6-7.3Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M214.3,327.7l14.1-8.1-.7-.4-13.4,7.7-9.3,5.4.4.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M229.2,320.1l-23.5,13.6.2.3.4.2,23.6-13.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M231.4,321.4l-.7-.4-23.6,13.6.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M232.9,322.3l-.7-.4-23.6,13.6.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M234.4,323.2l-.7-.4-23.6,13.6.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M235.9,324.1l-.7-.4-23.5,13.6.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M237.4,325l-.7-.4-23.5,13.5.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M238.9,325.9h0l-.7-.4L214.8,339l.7.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M239.9,327.1l-.3-.6-23.2,13.4.8.3Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M240,328l-21.6,12.5a3.3,3.3,0,0,0,1.4,0l20-11.5A3,3,0,0,0,240,328Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M223.1,297.9v-.8l-34.6,20,.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M241.7,286.4l.8.3,45.8-26.4a2.1,2.1,0,0,0-.4-.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M223.1,299.7v-.8L190,318l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M245.2,287l43.3-25a2.8,2.8,0,0,0,.1-.9l-44.8,25.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M223.2,301.4v-.8l-31.6,18.2.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M266.3,275.7h1.5L283,267l-.7-.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M223.2,303.2v-.8l-30.1,17.3.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M269,275.9l.9.3,14.5-8.4-.7-.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M270.7,276.7l.7.4,14.5-8.3-.7-.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M223.3,304.9v-.8l-28.6,16.5.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M272.3,277.6l.8.3,13.8-8a2.1,2.1,0,0,0-.4-.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M223.3,306.6v-.8l-27.1,15.7.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M223.4,308.4v-.8l-25.6,14.7.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M275.6,278.2l11.4-6.6a2.8,2.8,0,0,0,.1-.9l-12.9,7.4A2.3,2.3,0,0,0,275.6,278.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M223.4,310.1v-.8l-24.1,13.9.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M223.4,311.1l-22.6,13h.2l.3.5,22.2-12.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M223.5,313.6v-.8l-21.9,12.6.3.7Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M223.5,315.3v-.8l-21.2,12.3.3.6Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M223.8,316.9h-.2v-.5L203,328.1l.3.7Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M225.3,317.8l-.6-.4-21,12.1.3.6Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M226.9,318.7l-.7-.4-21.8,12.6.3.6Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M260.9,247.8l-1-.2-13,7.5-92.7,53.5.7.4,65.9-38Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M263.2,248.3l-1-.2L155.7,309.4l.7.5Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M265.4,248.8l-1-.2L157.3,310.3l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M267.7,249.2l-1-.2L158.8,311.2l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M268.9,249.5,160.3,312.1h.1l1,.2,108.5-62.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M272.2,250.2l-1-.2L162.8,312.4l1.1.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M273.8,251l-.6-.4L165.3,312.7l1.2.2Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M275.4,251.9l-.7-.4L167.9,313.1H169Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M276.8,252.8l-.6-.4-105.8,61h1.1Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M277.7,253.3,175.9,312a4.5,4.5,0,0,1,2-.4l100.5-57.9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M279.2,254.2,179.1,311.9l.7.3,100-57.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M281.4,255.5l-.7-.4-100,57.6.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M282.8,256.4l-.6-.4-100,57.6.8.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M222.9,292.7v-.8l-39.1,22.6.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M236.2,284.3h1.2l46.9-27.1-.7-.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M223,294.4v-.7l-37.7,21.6.8.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M238.6,284.7l.8.4,46.5-26.8-.7-.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M223,296.2v-.8l-36.1,20.8.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M240.2,285.5l.7.4,46.5-26.8-.7-.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M132.8,296.2l.7.4,95.9-55.3-1-.2Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M117.4,305.8l-.7-.4L93.4,318.9l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M118.9,306.7l-.6-.4L94.9,319.8l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M134.3,297l.7.5,96.7-55.8-1.1-.2Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M135.8,297.9l.7.4,97.4-56.1-1.1-.2Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M120.4,307.6l-.7-.4L96.4,320.7l.6.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M137.4,298.8l.7.4,98-56.5-1-.2Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M121.9,308.5h-.1l-.5-.3L97.9,321.6l.7.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M138.9,299.7l.7.4,98.8-57-1.1-.2Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M122.8,309.8l-.3-.6L99.4,322.5c.3.1.5.3.8.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M123,310.6l-21.6,12.5h1.3l20.2-11.6C122.9,311.3,123,311,123,310.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M240.7,243.6l-1.1-.2-99.2,57.2.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M242.9,244.1l-1-.2L142,301.5l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M245.2,244.6l-1-.3L143.5,302.4l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M247.4,245l-1-.2L145,303.2l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M249.7,245.5l-1-.2L146.6,304.1l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M251.9,246l-1-.3L148.1,305l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M254.2,246.4l-1.1-.2L149.6,305.9l.7.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M256.4,246.9l-1-.2L151.1,306.8l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M258.7,247.4l-1-.2-105,60.5.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M195.6,234.3l-1-.2L74.7,303.2l.4.3h.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M197.9,234.7l-1-.2L76.2,304.1l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M200.2,235.2l-1.1-.2L77.7,305l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M202.4,235.7l-1-.2L79.2,305.9l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M204.6,236.1l-1-.2L80.7,306.8l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M206.9,236.6l-1-.2L82.2,307.7l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M209.1,237.1l-1-.2L83.7,308.6l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M210.4,237.3,85.2,309.5h.2l.2.5,125.8-72.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M109.1,298.3l.2-.9L86,310.8l.3.6Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M120.9,290.7h1.4L213.7,238l-1-.2Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M108.8,300.3v-.9L86.7,312.2l.3.6Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M123.5,291l.8.3,91.6-52.8-1-.2Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M110,301.3l-.7-.4-22,12.7.3.6Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M125.2,291.8l.7.4,92.3-53.3-1-.2Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M126.7,292.6l.7.5,93.1-53.7-1.1-.2Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M111.5,302.3l-.7-.5L88,315l.3.6Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M128.2,293.5l.7.4,93.8-54-1.1-.2Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M113,303.1l-.7-.4L88.9,316.2l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M114.5,304l-.7-.4L90.4,317.1l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M129.8,294.4l.7.4,94.4-54.4-1-.3Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M116,304.9l-.7-.4L91.9,318l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M131.3,295.3l.7.4,95.2-54.9-1-.2Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M164.1,227.7l-1-.2L67.3,282.7l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M166.4,228.2l-1-.2L68.9,283.6l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M168.6,228.6l-1.1-.2L70.4,284.5l.7.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M170.9,229.1l-1.1-.2L71.9,285.3l.7.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M173.1,229.6l-1-.2L73.4,286.2l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M175.4,230l-1.1-.2L75,287.1l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M177.6,230.5l-1-.2L76.5,288l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M179.9,231l-1-.2L78.1,288.9l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M182.1,231.5l-1-.3L79.6,289.8l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M183.4,231.7l-102.3,59,.5.3h.2l102.6-59.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M186.6,232.4l-1-.2L82.4,291.7l.3.6Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M188.9,232.9l-1-.2-105,60.5a2.9,2.9,0,0,1-.2.9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M191.1,233.3l-1-.2L74.5,299.7a1.6,1.6,0,0,0-.5,1.1Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M193.4,233.8l-1-.2L74,301.8a1.9,1.9,0,0,0,.2.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M40,237.3h0Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M45.1,236.1l-2.2.5-4.6,2.7-1.5,1.6Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M49.8,235.2l-2.2.4-12.5,7.2-1.4,1.7Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M54.7,234.1l-2.2.5L31.9,246.5l-1.4,1.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M59.5,233.1l-2.2.5L22.1,253.9a2.9,2.9,0,0,0-.3,1Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M64.3,232.1l-2.2.5L21.9,255.8l.3.6Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M128,220.2l-1-.2L42.4,268.8l.9.3Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M129.3,220.5l-85,49h.1l.6.4,85.3-49.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M132.5,221.1l-1-.2L45.8,270.3l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M134.8,221.6l-1-.2L47.3,271.2l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M137,222.1l-1-.2L48.8,272.1l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M139.3,222.5l-1.1-.2L50.4,273l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M141.5,223l-1-.2L51.9,273.9l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M143.8,223.5l-1-.2L53.5,274.7l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M146,223.9l-1-.2L55,275.6l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M148.3,224.4l-1-.2L56.6,276.5l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M150.6,224.9l-1.1-.2L58.1,277.4l.7.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M152.8,225.4l-1-.2L59.6,278.3l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M155,225.8l-1-.2L61.1,279.1l.7.5Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M157.3,226.3l-1-.2L62.7,280l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M159.5,226.8l-1-.3L64.2,280.9l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M161.8,227.2l-1-.2-95,54.8.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M67.1,231.5,22.8,257H23l.5.3L69.3,231Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M74,230.1l-2.2.5L24.3,257.9l.7.5Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M78.9,229.1l-2.2.4L25.9,258.8l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M83.6,228.1l-2.1.4L27.4,259.7l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M86.3,227.5,29,260.6l.7.4,58.8-33.9Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M93.3,226.1l-2.2.5-60.8,35,.4.6Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M30.8,263.9,98.2,225l-2.2.5L30.9,263A2.8,2.8,0,0,1,30.8,263.9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M103,224.1l-2.2.4L25.6,267.8l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M107.8,223l-2.2.5L27.2,268.7l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M112.5,222.1l-2.2.4L28.7,269.6l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M117.4,221l-2.2.5L30.3,270.4l.8.3Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M119.9,220.5,32.2,271.1h1.3L122.1,220Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M125.8,219.7l-1-.2L38.9,269a7.8,7.8,0,0,1,2.1-.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M40.9,235.6l-.7-.4-12.6,7.3.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M42.4,236.4l-.7-.4-12.6,7.3.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M44,237.3l-.7-.4-12.7,7.3.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M45.5,238.1l-.7-.4-12.7,7.4.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M47.1,239l-.7-.4-12.7,7.3.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M48.4,240l.2-.2-.7-.3-12.7,7.3.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M43.6,244.5l2.2-2.1-9.1,5.3.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M41.1,246.9l-2.9,1.6.7.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M20.4,226.4a10,10,0,0,0-2.9,1l-3.7,2.1a3.7,3.7,0,0,0-1.2,1.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M22.2,226.3,12.4,232a2.2,2.2,0,0,0,.1.8l11-6.3A3.2,3.2,0,0,0,22.2,226.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M25.4,227l-.8-.3-11.8,6.8.4.6Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M26.3,227.5l-12.4,7.2.7.4,12.5-7.2Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M28.5,228.7l-.7-.4-12.4,7.2.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M30.1,229.6l-.7-.4-12.5,7.2.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M31.6,230.4l-.7-.4-12.5,7.3.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M33.1,231.3l-.7-.4-12.5,7.2.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M34.7,232.1l-.7-.4L21.4,239l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M36.2,233l-.7-.4L23,239.8l.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M37.8,233.9l-.7-.4-12.6,7.2.7.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M38.6,234.3,26,241.6l.7.4,12.6-7.3Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M156.6,155.8,32.3,227.6l.3.6L157,156.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M158.2,156.6,33.8,228.4l.4.6,124.3-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M159.7,157.5,35.3,229.2l.3.6,124.5-71.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M161.3,158.4,36.9,230.1l.4.6L161.7,159Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M162.6,159.3,38.2,231.1l.4.6L163,159.9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M164.2,160.1,39.8,231.9l.3.6,124.5-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M165.8,161.1,41.3,232.8l.4.6,124.4-71.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M167.3,161.9,42.9,233.6l.4.6,124.4-71.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M168.7,162.8,44.3,234.6l.4.6,124.4-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M170.3,163.7,45.9,235.4l.4.6,124.4-71.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M171.8,164.5,47.4,236.3l.4.6,124.4-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M173.5,165.4,49,237.1l.4.7L173.8,166Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M174.8,166.3,50.4,238l.4.6,124.4-71.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M176.4,167.2,51.9,239l.4.6,124.4-71.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M177.9,168.1,53.4,239.8l.4.6,124.4-71.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M179.4,168.9,55,240.7l.4.6,124.4-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M180.9,169.8,56.5,241.5l.4.6,124.4-71.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M135.3,143.6,11,215.4l.3.6,124.4-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M136.9,144.4,12.6,216.2l.3.6L137.3,145Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M138.3,145.3,13.9,217.1l.4.6,124.3-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M139.9,146.2,15.6,218l.3.6,124.4-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M141.3,147.1,17,218.9l.3.6,124.4-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M143,147.9,18.6,219.7l.4.6,124.3-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M144.4,148.8,20,220.6l.4.6,124.3-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M146,149.7,21.7,221.5l.3.6,124.4-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M147.5,150.6,23.2,222.4l.3.6,124.4-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M149.1,151.4,24.7,223.2l.4.6L149.5,152Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M150.4,152.3,26,224.1l.4.6,124.3-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M152,153.2,27.7,225l.3.6,124.4-71.8Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M153.5,154,29.1,225.8l.4.7,124.4-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M155.1,154.8,30.7,226.7l.4.6,124.3-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M156.5,155.8,32.2,227.6l.3.6,124.3-71.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M130.1,44.2l-9.8-12.9,2-4.3,11.3-8.3,4-.8h6l3.6,2.2,2.6,11.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M251.4,83.3,141.6,19.1l4.3,176.6,104.6,67.2c1.7,1,3.1,0,3.1-2.3l.9-171.3C254.5,87,253.2,84.3,251.4,83.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M251.8,264.6a3.5,3.5,0,0,1-1.9-.6L144.6,196.4v-.7l-4.4-179,112,65.4c2.1,1.2,3.8,4.4,3.8,7.2l-.9,171.3a4.1,4.1,0,0,1-1.8,3.7A4,4,0,0,1,251.8,264.6ZM147.3,195l104,66.7c.3.2.5.2.6.1s.4-.5.4-1.3l.9-171.3a6.3,6.3,0,0,0-2.4-4.8L143,21.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M245.8,257,230,266.1l-13.9-32-70.2-41,.5-118.8L128,33.3c7.2-8.5,13.4-8.5,13.4-8.5L245,85.3a7.6,7.6,0,0,1,3.1,6l-.7,162.9A4.1,4.1,0,0,1,245.8,257Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M229.4,268,215,235l-70.5-41.2V193L145,74.7,126.4,33.2l.6-.7c7.5-8.8,14.1-9,14.4-9h.4l.3.2L245.7,84.2c2.1,1.2,3.8,4.4,3.8,7.2l-.7,162.9c0,2.1-1.9,3.6-2.1,3.8h-.1Zm-82.1-75.7,69.9,40.8,13.5,31,14.4-8.3a2.3,2.3,0,0,0,.9-1.5l.7-162.9a6.3,6.3,0,0,0-2.4-4.8L141.1,26.3c-1.2.2-6,1.1-11.5,7.3l18.1,40.5v.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M247.6,88.7a8.6,8.6,0,0,1,.5,2.7l-.7,162.9a4.1,4.1,0,0,1-1.5,2.7l-15.8,9.1-13.9-32-22.9-13.4-43.5-76.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M253.6,260.6l.9-171.3a7.6,7.6,0,0,0-3.1-6L144.7,20.9a6.2,6.2,0,0,0-5-.6c-4,1.2-6.7,1.3-14.3,8.7a1.9,1.9,0,0,0,.4,3L232.4,94.3a7.6,7.6,0,0,1,3.1,6l-.9,171.3c0,2.3-5.2,6.3-6.9,5.3,1.3.3,2.3-.8,2.3-2.7l.9-171.3a7.6,7.6,0,0,0-3.1-6l-100.9-59-8.8-5s-3-5.7,10.1-13.2,14.8-4.1,18.1-3.4L256.1,80.5a7.6,7.6,0,0,1,3.1,6l-.9,171.4c0,1.6-4.7,5.9-6.5,5.4C252.2,262.8,253.4,262.6,253.6,260.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M228.4,278.5a2.5,2.5,0,0,1-1.3-.3L220,274l8,1.6h.3c.2-.1.4-.5.4-1.3l.9-171.3a6.3,6.3,0,0,0-2.4-4.8l-100.9-59L117.2,34l-.2-.4c-.1-.3-3.4-7,10.7-15,11.4-6.5,14.8-5.1,17.6-4l1.4.5.4.2L256.9,79.5c2.1,1.2,3.8,4.4,3.8,7.2L259.8,258c0,2.2-3.7,5.1-3.9,5.2-1.8,1.3-3.3,1.8-4.4,1.5l-2-.6,1.4-1.6c.2-.3.5-.4.7-.6a1.6,1.6,0,0,0,.8-1.3l.9-171.2a6.3,6.3,0,0,0-2.4-4.8L144,22.1a4.9,4.9,0,0,0-3.9-.5l-1.2.3c-3.3.9-5.9,1.6-12.5,8-.2.2-.2.3-.2.4a.5.5,0,0,0,.3.4L233.1,93c2.1,1.2,3.8,4.4,3.8,7.2L236,271.5c0,2.4-2.9,4.9-4.8,6A5,5,0,0,1,228.4,278.5ZM119.2,32.1l8.3,4.7,100.9,59c2.1,1.2,3.8,4.4,3.8,7.2l-.9,171.1a5,5,0,0,0,1.9-2.5l.9-171.3a6.3,6.3,0,0,0-2.4-4.8L125.1,33.2a3.2,3.2,0,0,1-.6-5.1c7.1-6.9,10.1-7.8,13.7-8.7l1.2-.3a7.7,7.7,0,0,1,6.1.8L252.2,82.2c2.1,1.2,3.8,4.4,3.8,7.2l-.9,170.9A6.8,6.8,0,0,0,257,258l.9-171.2a6.3,6.3,0,0,0-2.4-4.8L145.7,17.8a7.6,7.6,0,0,1-1.6-.6c-2.2-.9-5-2-15.2,3.8S119,30.9,119.2,32.1Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M227.9,97.2,118.2,33.1c-.1,0-.1,0-.1.1l-.9,175.3a7,7,0,0,0,3.6,6.2l106.3,62.1c1.7,1,3.1,0,3.1-2.3l.9-171.3C231,100.9,229.6,98.2,227.9,97.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M228.2,278.6a3.5,3.5,0,0,1-1.9-.6L120,215.9a8.4,8.4,0,0,1-4.2-7.4l.9-176.1,1.4-.9.8.4L228.6,96c2.1,1.2,3.8,4.4,3.8,7.2l-.9,171.3a4.1,4.1,0,0,1-1.8,3.7A4.2,4.2,0,0,1,228.2,278.6ZM119.4,35.4l-.9,173.1a5.7,5.7,0,0,0,2.9,5l106.3,62.1a1.2,1.2,0,0,0,.7.2c.2-.1.4-.5.4-1.3l.9-171.3a6.3,6.3,0,0,0-2.4-4.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M234.3,96.3a8.2,8.2,0,0,1,1,3.7l-.9,171.3c0,2.3-5.2,6.3-6.9,5.3,1.3.3,2.3-.8,2.3-2.7l.9-171.3a8.2,8.2,0,0,0-1-3.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M259,86.2l-.9,171.3c0,1.6-3.5,5.3-5.3,4.8a3.3,3.3,0,0,0,.6-2.1l.9-171.3a8.6,8.6,0,0,0-.9-3.5l4.6-2.7A7.8,7.8,0,0,1,259,86.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M235.7,261.9h-2.1l.8-159.1a26.1,26.1,0,0,0-.5-4.8l2.1-.5a23.1,23.1,0,0,1,.6,5.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M240.7,258.8h-1.3l.9-159.1a27.2,27.2,0,0,0-.5-4.9l1.2-.3a22.1,22.1,0,0,1,.5,5.1Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M245.1,256.3h-1.3l.8-159.1a27.2,27.2,0,0,0-.5-4.9l1.2-.3a17.7,17.7,0,0,1,.5,5.1Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M239.2,94.2a7,7,0,0,0-2.7-2.7L131.8,30.3l.8-1.4L237.3,90.1a8.7,8.7,0,0,1,3.3,3.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M243.5,91.7a7,7,0,0,0-2.7-2.7L134.5,27l.8-1.4,106.3,62a8.7,8.7,0,0,1,3.3,3.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M248.7,171.2V146.1l-15.3-8.8-.3,24.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M250,173.5l-18.3-10.6.3-28.1,18.1,10.5Zm-15.5-12.1,12.8,7.4V147l-12.6-7.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-3" d="M241.5,152.7l-8.5-4.9-.3,24.9,8.8,5Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M240.8,178.9l-9.5-5.4.3-28.1,10.6,6.1-1.3,2.4-6.6-3.7-.2,21.7,8.1,4.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-2" d="M250.2,191.2l-7.8-4.2v11l7.9,4.8Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M249.5,204l-8.6-5.2V184.7l9.9,5.3-1.3,2.4-5.9-3.1v8l7.2,4.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M216.2,78.2s-2.1-14.6,7.6-22.6l-14-8.7-7,19,.9,5Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M218,80.8l-15.5-9.1-1.1-6,7.7-21,17.1,10.6-1.5,1.2c-9,7.4-7.1,21.2-7.1,21.4ZM204.9,70l9.7,5.7c-.1-4.5.5-13.6,6.9-19.9l-11-6.9L204.2,66Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      id="bookmark"
      class="cls-4"
      d="M206.2,72.3s-2.6-17.5,13.9-29.7c0,0,8.4-5.2,3.7-9.6l-10.3-5.6c-.2-.1-.4.1-.4.3s1.4,5.5-4,8.3-14.8,16-14.8,29.5Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M71.4,215.1h-1v10.8h1Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M103.1,263.9h5.8L130,251.7a5.2,5.2,0,0,1,4.4-.2l47.8,27.6h.1l15.9,5.3a.7.7,0,0,1,.4.5v4a1.7,1.7,0,0,1-1,1.7l-26.3,15.2a5.2,5.2,0,0,1-4.4.2l-63.4-36.6a1.3,1.3,0,0,1-.7-1.1v-4C102.6,264.2,102.9,263.9,103.1,263.9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M166.5,306.5l-63.4-36.6a1.9,1.9,0,0,1-1-1.5v-4a1,1,0,0,1,1-1h5.5l21.1-12.2a5.6,5.6,0,0,1,4.9-.2l47.8,27.6,15.9,5.3a1,1,0,0,1,.7,1v3.9c.2.8-.3,1.6-1.3,2.2l-26.4,15.3a5.2,5.2,0,0,1-2.7.7A3.5,3.5,0,0,1,166.5,306.5Zm-36.3-54.2-21,12.1c-.2.1-.3.2-.5.1h-5.5v4c0,.3.3.5.5.7l63.4,36.6a4.2,4.2,0,0,0,3.9-.2l26.3-15.2c.6-.3.9-.8.8-1.1v-4.1l-15.9-5.3H182l-47.8-27.6a3.8,3.8,0,0,0-1.6-.4A4.8,4.8,0,0,0,130.2,252.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M103.4,265.2l63.4,36.6a4.9,4.9,0,0,0,4.4-.2l26.3-15.2c1.3-.7,1.4-1.9.3-2.5l-63.4-36.6a4.9,4.9,0,0,0-4.4.2l-26.3,15.2C102.4,263.4,102.2,264.5,103.4,265.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M166.5,302.2l-63.4-36.6a1.9,1.9,0,0,1-1-1.5,2.4,2.4,0,0,1,1.3-1.9L129.7,247a5.6,5.6,0,0,1,4.9-.2L198,283.4a1.9,1.9,0,0,1,1,1.5,2.4,2.4,0,0,1-1.3,1.9L171.4,302a5.2,5.2,0,0,1-2.7.7A4.5,4.5,0,0,1,166.5,302.2Zm-36.3-54.3-26.3,15.2a1.4,1.4,0,0,0-.8,1c0,.3.3.5.5.7L167,301.4a4.2,4.2,0,0,0,3.9-.2L197.2,286a1.4,1.4,0,0,0,.8-1c0-.3-.3-.5-.5-.7l-63.4-36.6a3.8,3.8,0,0,0-1.6-.4A4.6,4.6,0,0,0,130.2,247.9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-3" d="M168.1,302.2h-.8V306h.8Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-3" d="M194.5,285.7h-.8v3.8h.8Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-3"
      d="M75,118.5a.1.1,0,0,1,0-.2l4.7-2.6a.9.9,0,0,1,1,0l142,82a3.2,3.2,0,0,1,1.4,2.7V309.1a1.6,1.6,0,0,1-.4,1.1l-5,2.7-4.9-5.9,1.9-.8-135-78a3.2,3.2,0,0,1-1.4-2.7V124.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M223.9,199.1a4,4,0,0,0-1.1-1.4l-133.7-77a.9.9,0,0,0-1,0l-4.8,2.7-3.8,1v30.5l107.3,52.4,5.2,10.4,27.1-15.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M213,306.7l1.6-.7L80.4,228.5a3.8,3.8,0,0,1-1.6-3.1V124.5l-4.2-5.8a.4.4,0,0,1-.1-.5c0-.2.2-.3.3-.4l4.6-2.6a1.4,1.4,0,0,1,1.5,0l142,82a3.8,3.8,0,0,1,1.6,3.1V309a1.6,1.6,0,0,1-.7,1.5l-5.3,2.9ZM80,116.1l-4.3,2.4,4.2,5.7V225.4a2.8,2.8,0,0,0,1.1,2.2l135.9,78.5-2.2,1,4.2,5.1,4.5-2.5a1,1,0,0,0,.2-.7V200.3a2.8,2.8,0,0,0-1.1-2.2l-142-82H80Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M75.7,230.8l142,82c.8.4,1.4,0,1.4-1V203.1a3.5,3.5,0,0,0-1.4-2.7l-142-82c-.8-.4-1.4,0-1.4,1V228.1A3.4,3.4,0,0,0,75.7,230.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M217.5,313.2l-142-82a3.8,3.8,0,0,1-1.6-3.1V119.5a2,2,0,0,1,.7-1.6,1.4,1.4,0,0,1,1.4.1l142,82a3.8,3.8,0,0,1,1.6,3.1V311.8a2,2,0,0,1-.7,1.6l-.6.2ZM75.1,118.8a1,1,0,0,0-.2.7V228.2a2.8,2.8,0,0,0,1.1,2.2l142,82h.4a1,1,0,0,0,.2-.7V203.1a2.8,2.8,0,0,0-1.1-2.2l-142-82h-.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M75.9,228.8l141.6,81.7c.2.1.4,0,.4-.3V202.5a1.2,1.2,0,0,0-.4-.8L75.9,120c-.2-.1-.4,0-.4.3V228A1.2,1.2,0,0,0,75.9,228.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M83.5,132.9c-.2-.1-.4,0-.4.3v86.2a.8.8,0,0,0,.4.7l86.8,50.1,31,17.9,8.9,5.1c.2.1.4,0,.4-.3V206.7a.8.8,0,0,0-.4-.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M210.3,293.8h-.5L83.2,220.5a1.4,1.4,0,0,1-.7-1.2V133.1a.9.9,0,0,1,.4-.8,1.1,1.1,0,0,1,.8,0l-.6,1h.4l.2-.2v86.2c0,.1,0,.2.1.2l126.1,72.8V206.7c0-.1,0-.2-.1-.2l.6-1a1.4,1.4,0,0,1,.7,1.2v86.2a.9.9,0,0,1-.4.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M217.3,311,75.7,229.2A1.4,1.4,0,0,1,75,228V120.3a.9.9,0,0,1,.4-.8h.8l141.6,81.7a1.4,1.4,0,0,1,.7,1.2V310.1a.9.9,0,0,1-.4.8h-.4C217.6,311.1,217.4,311,217.3,311ZM76,228c0,.1.1.3.2.3l141.2,81.5V202.5c0-.1-.1-.3-.2-.3L76,120.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M74.3,228.3v-6.2l144.8,83.6v6.2c0,1-.7,1.3-1.5.9L75.8,230.9A3.5,3.5,0,0,1,74.3,228.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M217.4,313.2,75.6,231.3a3.8,3.8,0,0,1-1.7-3v-7.1l145.5,84h.3v6.5a1.7,1.7,0,0,1-.7,1.4l-.6.2ZM74.8,222.9v5.3a2.7,2.7,0,0,0,1.2,2.1l141.8,81.9a.7.7,0,0,0,.6.1.8.8,0,0,0,.2-.5v-5.9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M223.8,198.3l-4.8,3,.5.8,4.9-2.9Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M88.4,119.7l-4.9,2.9.5.9,4.9-2.9Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M223.8,301.2l-4.9,3,.6.8,4.8-2.9Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-3" d="M187.7,295.9l.4-.6-3.1-1.8-.4.6Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M224.1,297.5l-4.9,2.9.5.9,4.9-2.9Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M91.5,121.5l-4.8,3,.5.8,4.9-2.9Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M224.2,203.5l-4.9,2.9.5.9,4.9-2.9Z" transform="translate(-0.6 -13.7)" />
    <g>
      <g class="like-boxes">
        <path
          class="cls-3"
          d="M164.7,186.7l-19.6-11.3a3.1,3.1,0,0,0-2.9-.3l-6.4,4h0c.3.6,2.9,6.2,3.2,7.2s.9,4.7,1.9,9.6v2.5a8.9,8.9,0,0,0,1.3,4.3l1.9,9.7,2.9,6.9h.1l6.6-3.9h0l-.5-1.4-.3-2.2,8.5,9.4h.1l6.2-3.8h.1a3.2,3.2,0,0,0,1.2-2.7V194.1A9.9,9.9,0,0,0,164.7,186.7Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M161.3,222.1l-.5-.4-6.9-7.7.6,1.7-.5.4-6.9,4h-.4a1,1,0,0,1-.5-.4l-2.9-7-1.9-9.6a9.1,9.1,0,0,1-1.4-4.6V196c-1.4-7.4-1.8-9.3-1.9-9.6s-2-4.7-3.1-7l-.3-.6.6-.4,6.8-4.2h.1a4,4,0,0,1,3.1.5l19.6,11.3a10.4,10.4,0,0,1,4.6,8v20.5a3.6,3.6,0,0,1-1.5,3.3h-.1Zm-9.2-12.3,9.4,10.5,5.7-3.5.5.5-.4-.6a2.5,2.5,0,0,0,.9-2.1V194.1a8.8,8.8,0,0,0-3.9-6.8L144.7,176a2.3,2.3,0,0,0-2.2-.3l-5.8,3.6c.7,1.6,2.8,5.8,3,6.8s.7,3.6,1.9,9.7h0v2.5a7.7,7.7,0,0,0,1.2,3.9h.1v.2c.9,4.8,1.8,9,1.9,9.6l2.6,6.1,5.6-3.2-.4-1-.3-2.3Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-2"
          d="M164.6,186.7l-19-11-9.2,5.8,20.3,10.8,4.1.7,6.4-3.8A6.9,6.9,0,0,0,164.6,186.7Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M161,193.6l-4.6-.8-21.3-11.3,10.6-6.7L165,186a8.9,8.9,0,0,1,2.8,2.7l.4.6Zm-4.1-2,3.8.6,5.5-3.3a7.5,7.5,0,0,0-1.9-1.7l-18.6-10.8-7.9,4.9Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M162.4,196.3l-8.5,2.1a107.9,107.9,0,0,0-10.9,9.4l.9,4.7,2.9,6.9h.1l6.6-3.9h0L153,214l-.3-2.2,8.5,9.4h.1l6.2-3.8h.1a3.2,3.2,0,0,0,1.2-2.7V194.1a10,10,0,0,0-.2-1.6Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-3"
          d="M168.1,195.5l-4.7,2.8.5.8,4.7-2.9Z"
          transform="translate(-0.6 -13.7)"
        />
        <path class="cls-3" d="M168,214.4l-4.7,2.8.5.8,4.7-2.9Z" transform="translate(-0.6 -13.7)" />
        <path
          class="cls-3"
          d="M158.4,190.6l-19.6-11.3c-2.3-1.4-4.2-.3-4.2,2.4v20.6a9.3,9.3,0,0,0,4.2,7.3l2.2,1.3a2,2,0,0,1,.8,1.3,10.7,10.7,0,0,0,4.3,7.1c.6.5,1.1.1.9-.7a29.4,29.4,0,0,1-.5-3.5.6.6,0,0,1,.9-.5l10.9,6.3c2.3,1.4,4.2.3,4.2-2.4V197.9A8.9,8.9,0,0,0,158.4,190.6Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M160.3,222.2a3.8,3.8,0,0,1-2.2-.7l-10.7-6.2a18.8,18.8,0,0,0,.4,3.1,1.3,1.3,0,0,1-.5,1.6,1.2,1.2,0,0,1-1.5-.2,12,12,0,0,1-4.6-7.6c0-.3-.3-.6-.5-.8l-2.2-1.3a10,10,0,0,1-4.6-7.9V181.6a3.8,3.8,0,0,1,1.6-3.4,3.6,3.6,0,0,1,3.7.3l19.6,11.3a10,10,0,0,1,4.6,7.9v20.6a3.8,3.8,0,0,1-1.6,3.4A2.3,2.3,0,0,1,160.3,222.2Zm-13.2-8.4.7.2,10.9,6.3a2.5,2.5,0,0,0,2.3.3,2.2,2.2,0,0,0,.9-2.1V197.9a8.7,8.7,0,0,0-3.9-6.7l-19.6-11.3a2.5,2.5,0,0,0-2.3-.3,2.2,2.2,0,0,0-.9,2.1v20.6a8.7,8.7,0,0,0,3.9,6.7l2.2,1.3a2.4,2.4,0,0,1,1.2,1.8,10.2,10.2,0,0,0,3.8,6.5,15,15,0,0,1-.4-3.5,1.4,1.4,0,0,1,.6-1.2Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-2"
          d="M149.5,193.7l1.4,4.1a2.3,2.3,0,0,0,.8,1.1l3.2,2.4c.9.6,1.2,2,.6,2.4l-2.3,1.3a.8.8,0,0,0-.3.9l.5,4c.1,1.1-.7,1.3-1.5.4l-2.8-3.4a1.4,1.4,0,0,0-1-.6h-2.8a1.9,1.9,0,0,1-1.5-2.1l.5-3.3a1.8,1.8,0,0,0-.3-1.2l-2.3-3.9c-.6-1.1-.3-2.1.6-1.7l3.2,1.3a.6.6,0,0,0,.8-.2l1.4-2.5C148,192,149.1,192.6,149.5,193.7Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M152.9,211.5a2.2,2.2,0,0,1-1.5-.8l-2.8-3.4-.4-.3h-2.8a2.2,2.2,0,0,1-1.5-.8,2.7,2.7,0,0,1-.7-2.2l.5-3.3a1.3,1.3,0,0,0-.2-.8l-2.3-3.9a2.3,2.3,0,0,1-.1-2.4,1.4,1.4,0,0,1,1.5-.3l3.2,1.3,1.4-2.4a1.1,1.1,0,0,1,1.2-.6,2.5,2.5,0,0,1,1.9,1.8l1.4,4.1a2.2,2.2,0,0,0,.5.8l3.2,2.4a3.3,3.3,0,0,1,1.2,2.4,1.2,1.2,0,0,1-.7,1.1l-2.3,1.3v.2l.5,4a1.5,1.5,0,0,1-.7,1.6Zm-4.8-5.9a2.2,2.2,0,0,1,1.5.8l2.8,3.4.3.3h0l-.5-4a1.4,1.4,0,0,1,.7-1.6l2.3-1.3a2.2,2.2,0,0,0-.7-1.2l-3.2-2.4a2.8,2.8,0,0,1-1-1.4l-1.4-4.1a1.7,1.7,0,0,0-.7-.9l-1.4,2.4a1.3,1.3,0,0,1-1.7.5l-3.1-1.3a1.2,1.2,0,0,0,.2.7l2.3,3.9a2.8,2.8,0,0,1,.4,1.7l-.5,3.3a1.4,1.4,0,0,0,.4,1l.4.3Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M152.3,191.4l-1.3.5,1.7,5.2,1.3-.5Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M141.2,200.1l-.5,3.5,1.3.2.6-3.4Z"
          transform="translate(-0.6 -13.7)"
        />
      </g>
      <g class="like-boxes">
        <path
          class="cls-3"
          d="M225.2,246.3l-20.4-11.8a3.1,3.1,0,0,0-3-.4l-6.7,4.1h0a76.4,76.4,0,0,1,3.3,7.5c.1.5,1,4.9,2,10v2.6a8.8,8.8,0,0,0,1.4,4.5c1,5.4,1.9,10,2,10.1l9.4,3.2h.7l-.5-1.5-.3-2.3,8.8,9.8h.1l6.4-4a.1.1,0,0,0,.1-.1,3,3,0,0,0,1.2-2.8V253.8A10,10,0,0,0,225.2,246.3Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M221.9,282.9a.9.9,0,0,1-.6-.3l-7.3-8.1.7,1.9-.7.5h-1l-9.8-3.3-.2-.4c0-.1-.9-4.6-1.9-10a9.7,9.7,0,0,1-1.4-4.7V256c-1.5-7.7-1.9-9.7-2-9.9s-1.8-4.2-3.3-7.3a.8.8,0,0,1,.3-1l7-4.3h.1a4.5,4.5,0,0,1,3.3.5l20.4,11.8a10.8,10.8,0,0,1,4.8,8.3v21.3a3.8,3.8,0,0,1-1.6,3.4l-6.5,4Zm-9.7-12.4,9.8,10.9,6-3.7.5.5-.4-.6a2.5,2.5,0,0,0,.9-2.2V254a9.2,9.2,0,0,0-4.1-7.1l-20.4-11.7a2.5,2.5,0,0,0-2.3-.3l-6.1,3.8a70.3,70.3,0,0,1,3.1,7.1c.1.4.8,3.8,2,10.1h0v2.6a8.2,8.2,0,0,0,1.3,4.1v.2c.9,4.5,1.6,8.5,1.9,9.7l8.5,2.8-.2-.6a9.7,9.7,0,0,1-.3-2.3Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-2"
          d="M225.2,246.3l-19.7-11.4-9.6,6L217,252.1l4.3.7,6.6-3.9A9.5,9.5,0,0,0,225.2,246.3Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M221.4,253.6l-4.8-.8-22.2-11.7,11-6.9,20.1,11.6a10.9,10.9,0,0,1,2.9,2.8l.4.6Zm-4.3-2.1,3.9.6,5.7-3.4a6.3,6.3,0,0,0-2-1.7l-19.2-11.3-8.2,5.2Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M222.9,256.3l-8.8,2.1a127.4,127.4,0,0,0-11.3,9.7c.6,2.9,8.7,7.9,8.7,7.9l3.1,7.5,7-4.1.2,2.7h.1l6.4-4a.1.1,0,0,0,.1-.1,3,3,0,0,0,1.2-2.8V253.8a8.8,8.8,0,0,0-.2-1.6Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-3"
          d="M228.8,255.5l-4.9,3,.5.7,4.8-2.9Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-3"
          d="M228.7,275.2l-4.8,3,.4.7,4.9-2.9Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-3"
          d="M198.3,238.6l20.4,11.8a9.8,9.8,0,0,1,4.4,7.6v21.4c0,2.8-2,4-4.4,2.5l-2.3-1.3c-.4-.2-.8-.1-.9.3s-1.2,3.6-4.5,2.3a2,2,0,0,1-1-1.9,10.9,10.9,0,0,0,.5-3,1.9,1.9,0,0,0-.9-1.5l-11.4-6.6a9.8,9.8,0,0,1-4.4-7.6V241.2C193.8,238.3,195.8,237.2,198.3,238.6Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M212.8,284.3a6.3,6.3,0,0,1-2.1-.5,2.5,2.5,0,0,1-1.4-2.7,9.3,9.3,0,0,0,.4-2.8,1.3,1.3,0,0,0-.5-.9l-11.4-6.6a10.3,10.3,0,0,1-4.8-8.2V241.2a4.1,4.1,0,0,1,1.6-3.5,3.8,3.8,0,0,1,3.8.3l20.4,11.8a10.3,10.3,0,0,1,4.8,8.2v21.4a4.1,4.1,0,0,1-1.6,3.5,3.8,3.8,0,0,1-3.8-.3l-2.2-1.3a3.6,3.6,0,0,1-1.8,2.6A2,2,0,0,1,212.8,284.3Zm-16.5-45.6-.8.2a2.4,2.4,0,0,0-.9,2.2v21.4a9.1,9.1,0,0,0,4.1,7l11.4,6.6a2.6,2.6,0,0,1,1.2,2.1,11.3,11.3,0,0,1-.5,3.2,1,1,0,0,0,.6,1,3,3,0,0,0,2.4.2,2.9,2.9,0,0,0,1.1-1.9,1.3,1.3,0,0,1,.7-.9,1.3,1.3,0,0,1,1.2.1l2.3,1.3c1,.5,1.8.7,2.4.3a2.4,2.4,0,0,0,.9-2.2V257.9a9.1,9.1,0,0,0-4.1-7l-20.4-11.8A5.3,5.3,0,0,0,196.3,238.7Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-2"
          d="M202.1,255.4s-1.6.1-1.3,3.9,1.6,5.5,1.6,5.5l3.1,1.1.2.3c2,2.8,4.7,4.3,6.7,3.8l1.2-.3-.2-8.1a12.7,12.7,0,0,1-2.6-3c-.9-1.6.3-1.7.2-3.5s-1.4-5-2.8-5.1-.8,1.6-.5,3a3.2,3.2,0,0,1-1.5,3.4,3.4,3.4,0,0,0-1.4,1.2A5.8,5.8,0,0,0,202.1,255.4Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M211.5,270.7c-2.1,0-4.6-1.6-6.4-4.2a.1.1,0,0,0-.1-.1l-3.1-1.1v-.2c-.1-.1-1.5-2-1.8-5.9a6.3,6.3,0,0,1,.8-4,1.6,1.6,0,0,1,1.2-.6h.4a6.5,6.5,0,0,1,2.3,1.6l1-.7a2.4,2.4,0,0,0,1.2-2.6c0-.2-.1-.4-.1-.7s-.5-2,.1-2.7a1.4,1.4,0,0,1,1.3-.5c2,0,3.4,3.8,3.5,5.7a6.8,6.8,0,0,1-.3,1.9,1.1,1.1,0,0,0,.1,1.3,13.2,13.2,0,0,0,2.4,2.8l.2.2.3,9-1.7.5A2.7,2.7,0,0,1,211.5,270.7Zm-8.6-6.5,3.1,1.1v.2l.2.2c1.8,2.5,4.2,4,5.9,3.5l.7-.2-.2-7.3a14,14,0,0,1-2.5-3,2.5,2.5,0,0,1-.1-2.5,4.9,4.9,0,0,0,.3-1.4c-.1-1.9-1.4-4.4-2.1-4.4h-.2a4.7,4.7,0,0,0,.2,1.5c.1.2.1.5.2.7a3.8,3.8,0,0,1-1.9,4.1,2.7,2.7,0,0,0-1.1.9l-.6,1.1-.6-1.1a4.5,4.5,0,0,0-2-1.6c-.3.2-.8,1-.6,3.1A9.6,9.6,0,0,0,202.9,264.2Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M204.9,266.2a10,10,0,0,1-.8-3h1.4a7,7,0,0,0,.6,2.4Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M205.2,259.2h-1.4c0-1.6.3-1.9.4-2l1.1.8A8.4,8.4,0,0,0,205.2,259.2Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-2"
          d="M215.1,265.4l-3.9-2.3a2.7,2.7,0,0,1-1.1-2.1c0-.8.5-1.2,1.1-.8l3.9,2.3a2.7,2.7,0,0,1,1.1,2.1C216.2,265.4,215.7,265.8,215.1,265.4Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M215.5,266.3l-.8-.2-3.9-2.3a3.6,3.6,0,0,1-1.5-2.7,1.8,1.8,0,0,1,.7-1.5,1.4,1.4,0,0,1,1.4.1l3.9,2.3a3.6,3.6,0,0,1,1.5,2.7,1.8,1.8,0,0,1-.7,1.5Zm-.1-1.5h0c.1,0,.1-.1.1-.2a1.9,1.9,0,0,0-.8-1.5l-3.9-2.3v.3a1.9,1.9,0,0,0,.8,1.5Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-2"
          d="M214.8,267.7l-3.4-2a2.3,2.3,0,0,1-.9-1.8c0-.7.4-1,.9-.7l3.4,2a2.3,2.3,0,0,1,.9,1.8C215.7,267.7,215.3,268,214.8,267.7Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M215.2,268.5l-.7-.2-3.4-2a2.9,2.9,0,0,1-1.3-2.4,1.5,1.5,0,0,1,.7-1.4,1.5,1.5,0,0,1,1.3,0l3.4,2a2.9,2.9,0,0,1,1.3,2.4,1.5,1.5,0,0,1-.7,1.4A.7.7,0,0,1,215.2,268.5Zm-4-4.5a1.6,1.6,0,0,0,.6,1.2l3.3,1.9a1.6,1.6,0,0,0-.6-1.2Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-2"
          d="M214.4,270l-3-1.7a2.3,2.3,0,0,1-.9-1.8c0-.7.4-1,.9-.7l3,1.7a2.3,2.3,0,0,1,.9,1.8C215.3,269.9,214.9,270.3,214.4,270Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M214.8,270.8l-.7-.2-3-1.7a2.9,2.9,0,0,1-1.3-2.4,1.5,1.5,0,0,1,.7-1.4,1.5,1.5,0,0,1,1.3,0l3,1.7a2.9,2.9,0,0,1,1.3,2.4,1.5,1.5,0,0,1-.7,1.4Zm-3.6-4.4a1.6,1.6,0,0,0,.6,1.2l2.9,1.7a1.6,1.6,0,0,0-.6-1.2Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-2"
          d="M213.9,272.1l-2.1-1.2a2.3,2.3,0,0,1-.9-1.8c0-.7.4-1,.9-.7l2.1,1.2a2.3,2.3,0,0,1,.9,1.8C214.8,272.1,214.4,272.4,213.9,272.1Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M214.3,272.9l-.7-.2-2.1-1.2a2.9,2.9,0,0,1-1.3-2.4,1.5,1.5,0,0,1,.7-1.4,1.5,1.5,0,0,1,1.3,0l2.1,1.2a2.9,2.9,0,0,1,1.3,2.4,1.5,1.5,0,0,1-.7,1.4A.7.7,0,0,1,214.3,272.9Zm-2.8-3.8a1.6,1.6,0,0,0,.6,1.2l2,1.2a1.6,1.6,0,0,0-.6-1.2Z"
          transform="translate(-0.6 -13.7)"
        />
      </g>
      <g class="like-boxes">
        <path
          class="cls-3"
          d="M31.4,183.4,11.8,172.1a3.1,3.1,0,0,0-2.9-.3l-6.4,4h0c.3.6,2.9,6.2,3.2,7.2s.9,4.7,1.9,9.6v2.5a8.9,8.9,0,0,0,1.3,4.3l1.9,9.7,2.9,6.9h.1l6.6-3.9h0l-.5-1.4-.3-2.2,8.5,9.4h.1l6.2-3.8h.1a3.2,3.2,0,0,0,1.2-2.7V190.8A10,10,0,0,0,31.4,183.4Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M28,218.8l-.5-.4-6.9-7.7.6,1.7-.5.4-6.9,4h-.4a1,1,0,0,1-.5-.4l-3-7h0L8,199.6A9.1,9.1,0,0,1,6.6,195v-2.4c-1.4-7.4-1.8-9.3-1.9-9.6s-1.7-4.1-3.1-7v-.5l.6-.4,6.8-4.2H9a4,4,0,0,1,3.1.5l19.6,11.3a10.4,10.4,0,0,1,4.6,8v20.5a3.6,3.6,0,0,1-1.5,3.3Zm-9.2-12.2,9.4,10.5,5.7-3.5.5.5-.4-.6a2.5,2.5,0,0,0,.9-2.1V190.9a8.8,8.8,0,0,0-3.9-6.8L11.4,172.8a2.3,2.3,0,0,0-2.2-.3l-5.8,3.6a65.7,65.7,0,0,1,3,6.8c.1.4.7,3.6,1.9,9.7h0v2.5a7.7,7.7,0,0,0,1.2,3.9v.2c1,4.9,1.8,9.2,1.9,9.6l2.6,6.1,5.6-3.2-.4-1.1-.3-2.2Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-2"
          d="M31.3,183.4l-19-11-9.2,5.8L23.4,189l4.1.7,6.4-3.8A7.7,7.7,0,0,0,31.3,183.4Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M27.7,190.4l-4.6-.8L1.7,178.3l10.6-6.7,19.3,11.2a8.9,8.9,0,0,1,2.8,2.7l.4.6Zm-4.1-2.1,3.8.6,5.5-3.3a7.5,7.5,0,0,0-1.9-1.7L12.4,173.1l-7.9,5.1Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M29.1,193l-8.5,2.1a107.9,107.9,0,0,0-10.9,9.4l.9,4.7,2.9,6.9h.1l6.6-3.9h0l-.5-1.4-.3-2.2,8.5,9.4H28l6.2-3.8h.1a3.2,3.2,0,0,0,1.2-2.7V190.8a10,10,0,0,0-.2-1.6Z"
          transform="translate(-0.6 -13.7)"
        />
        <path class="cls-3" d="M34.8,192.2,30,195l.5.8,4.7-2.9Z" transform="translate(-0.6 -13.7)" />
        <path
          class="cls-3"
          d="M34.8,211.2,30.1,214l.4.8,4.7-2.9Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-3"
          d="M25.1,187.3,5.4,176c-2.3-1.4-4.2-.3-4.2,2.4V199a9.3,9.3,0,0,0,4.2,7.3l2.2,1.3a2,2,0,0,1,.8,1.3,10.7,10.7,0,0,0,4.3,7.1c.6.5,1.1.1.9-.7a29.4,29.4,0,0,1-.5-3.5.6.6,0,0,1,.9-.5l10.9,6.3c2.3,1.4,4.2.3,4.2-2.4V194.6C29.3,192,27.4,188.7,25.1,187.3Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M27,219a3.8,3.8,0,0,1-2.2-.7l-10.7-6.2a18.8,18.8,0,0,0,.4,3.1,1.3,1.3,0,0,1-.5,1.6,1.2,1.2,0,0,1-1.5-.2A12,12,0,0,1,7.9,209c0-.3-.3-.6-.5-.8l-2.2-1.3A10,10,0,0,1,.6,199V178.4a3.5,3.5,0,0,1,1.6-3.3,3.6,3.6,0,0,1,3.7.3l19.6,11.3a10,10,0,0,1,4.6,7.9v20.6a3.8,3.8,0,0,1-1.6,3.4A4.2,4.2,0,0,1,27,219Zm-13.2-8.5.7.2L25.4,217a2.5,2.5,0,0,0,2.3.3,2.2,2.2,0,0,0,.9-2.1V194.6a8.7,8.7,0,0,0-3.9-6.7L5.1,176.6a2.5,2.5,0,0,0-2.3-.3,2.2,2.2,0,0,0-.9,2.1V199a8.7,8.7,0,0,0,3.9,6.7L8,207a2.4,2.4,0,0,1,1.2,1.8,10.2,10.2,0,0,0,3.8,6.5,15,15,0,0,1-.4-3.5,1.4,1.4,0,0,1,.6-1.2Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-2"
          d="M21.2,193.1c-2.5-3.6-5.3-2.2-5.9-1.3-.6-1.6-3.4-6.2-5.9-5.5s-2.1,3.8-.8,7.5,5.6,10.9,6.6,12.5.3.3.4.2,5.4-3.1,6.5-5S23.7,196.8,21.2,193.1Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M15.4,207.2a1.1,1.1,0,0,1-.9-.6c-1.3-2.2-5.6-9.7-6.7-12.6s-1.4-5.5-.7-6.9a2.8,2.8,0,0,1,2-1.5c2.6-.7,5.2,2.9,6.3,5.1a3.9,3.9,0,0,1,2-.6c1.1,0,2.7.5,4.2,2.6,3,4.3,2,7.2.9,9.2s-5.1,4.3-6.7,5.2ZM9.9,186.9H9.6a1.5,1.5,0,0,0-1.1.8c-.7,1.3.1,3.9.7,5.8s5.2,10.1,6.4,12.1c2.4-1.4,5.1-3.2,5.8-4.5s1.7-4.1-.8-7.7a4,4,0,0,0-3-2,2.5,2.5,0,0,0-1.7.7l-.2.3h-.8l-.2-.4C14,190.4,11.7,186.9,9.9,186.9Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M9.2,192.4c-.1-.4-.7-2.4.1-3.5a1.6,1.6,0,0,1,1.8-.6l-.2,1.4h-.6c-.3.4-.1,1.5.1,2.1Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-3"
          d="M15.5,202.9a18.9,18.9,0,0,0,2.7-1.7Z"
          transform="translate(-0.6 -13.7)"
        />
        <path
          class="cls-1"
          d="M15.8,203.6l-.6-1.3a21.7,21.7,0,0,0,2.6-1.7l.9,1.1C17.2,202.8,15.9,203.5,15.8,203.6Z"
          transform="translate(-0.6 -13.7)"
        />
      </g>
    </g>
    <path
      class="cls-2"
      d="M82.8,200.3l-6.1-3.5a8.4,8.4,0,0,1-3.8-4.5,12,12,0,0,0-5.2-6.1L55.3,179l12.5-7.3,12,6.8a12.1,12.1,0,0,1,5.5,6.3v.3a8.6,8.6,0,0,0,4.1,4.7l5.5,3.1Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M82.8,201l-6.4-3.6a9.6,9.6,0,0,1-4.1-4.8,11.6,11.6,0,0,0-4.9-5.8l-13.3-7.7,13.7-8,12.3,7a11.8,11.8,0,0,1,5.7,6.7v.3a8.2,8.2,0,0,0,3.8,4.4l6.5,3.6ZM56.5,179,68,185.7a12.3,12.3,0,0,1,5.5,6.4,7.8,7.8,0,0,0,3.6,4.2l5.8,3.3,10.9-6.5-4.6-2.6a9.2,9.2,0,0,1-4.3-5v-.3a11,11,0,0,0-5.2-6l-11.8-6.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M87.9,193.8l-4.2,2.5a1.6,1.6,0,0,1-1.5-.1l-2-1.2c-.5-.3-.5-.7-.1-.9l4.2-2.5a1.6,1.6,0,0,1,1.5.1l2,1.2A.5.5,0,0,1,87.9,193.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-3" d="M74.6,188.3l6.5-3.8Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M74.8,188.7l-.5-.8,1.6-.9.5.8Zm2.4-1.4-.5-.8,1.6-.9.5.8Zm2.4-1.4-.5-.8,1.6-.9.5.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M79.4,182.2,72.9,186l.4.7,6.5-3.7Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M69.5,175.4l-6.4,3.8.4.7,6.5-3.7Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M72.1,176.9l-6.5,3.8.4.7,6.5-3.7Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M74.6,178.3,68.1,182l.5.8,6.5-3.7Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-2"
      d="M75,181l-6.1-3.5a8.4,8.4,0,0,1-3.8-4.5,12,12,0,0,0-5.2-6.1l-12.4-7.2,20.6-11.8,12,6.8a12.1,12.1,0,0,1,5.5,6.3v.3a8.6,8.6,0,0,0,4.1,4.7l5.5,3.1Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M75,181.7l-6.4-3.6a9.6,9.6,0,0,1-4.1-4.8,11.6,11.6,0,0,0-4.9-5.8l-13.4-7.7L68,147.3l12.3,7A11.8,11.8,0,0,1,86,161v.3a8.2,8.2,0,0,0,3.8,4.4l6.5,3.6Zm-26.3-22,11.5,6.7a12.3,12.3,0,0,1,5.5,6.4,7.8,7.8,0,0,0,3.6,4.2l5.8,3.3,19-11.1-4.6-2.6a9.2,9.2,0,0,1-4.3-5v-.3a11,11,0,0,0-5.2-6l-11.7-6.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M72.1,176.6l-.5-.8,1.6-.9.5.8Zm2.4-1.4-.5-.8,1.6-.9.5.8Zm2.4-1.4-.5-.8,1.6-.9.5.8Zm2.5-1.4-.5-.8,1.6-.9.5.8Zm2.4-1.4-.5-.8,1.6-.9.5.8Zm2.4-1.4-.5-.8,1.6-.9.5.8Zm2.4-1.3-.5-.8.6-.3.5.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M75.4,156.3l-4.8,2.8a1.6,1.6,0,0,1-1.5-.1l-5.5-3.2c-.5-.3-.5-.7-.1-.9l4.8-2.8a1.6,1.6,0,0,1,1.5.1l5.5,3.2C75.8,155.7,75.8,156.1,75.4,156.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M81.1,160.3l-14.6,8.3.5.8,14.6-8.3Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M79.6,158.3,65,166.7l.5.7,14.6-8.3Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M61.5,156.3l-6.3,3.6.5.7,6.2-3.5Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M64,157.8l-6.2,3.6.4.7,6.3-3.5Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M66.5,159.2l-6.3,3.6.5.8,6.2-3.6Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M88.7,168.4l-14.6,8.4.4.7,14.6-8.3Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-2"
      d="M102.1,315.9,96,312.4a8.4,8.4,0,0,1-3.8-4.5,12,12,0,0,0-5.2-6.1l-12.5-7.1,20.6-11.8,12,6.8a12.1,12.1,0,0,1,5.5,6.3v.3a8.6,8.6,0,0,0,4.1,4.7l5.5,3.1Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M102.1,316.6,95.7,313a9.6,9.6,0,0,1-4.1-4.8,11.6,11.6,0,0,0-4.9-5.8l-13.4-7.7,21.8-12.5,12.3,7a11.8,11.8,0,0,1,5.7,6.7v.3a8.2,8.2,0,0,0,3.8,4.4l6.5,3.6ZM75.7,294.7l11.5,6.7a12.3,12.3,0,0,1,5.5,6.4,7.8,7.8,0,0,0,3.6,4.2l5.8,3.3,19-11.1-4.6-2.6a9.2,9.2,0,0,1-4.3-5v-.3a11,11,0,0,0-5.2-6l-11.7-6.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-3" d="M98.9,311.1l15.2-8.7Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M99.1,311.5l-.5-.8,1.6-.9.5.8Zm2.4-1.4-.5-.8,1.6-.9.5.8Zm2.5-1.4-.5-.8,1.6-.9.5.8Zm2.4-1.4-.5-.8,1.6-.9.5.8Zm2.4-1.3-.5-.8,1.6-.9.5.8Zm2.5-1.4-.5-.8,1.6-.9.5.8Zm2.4-1.4-.5-.8.6-.3.5.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M93.8,295.9,89,298.7a1.6,1.6,0,0,1-1.5-.1L82,295.4c-.5-.3-.5-.7-.1-.9l4.8-2.8a1.6,1.6,0,0,1,1.5.1l5.5,3.2C94.2,295.3,94.2,295.7,93.8,295.9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M108.2,295.3l-14.6,8.4.4.7,14.6-8.3Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M106.7,293.3l-14.6,8.4.4.7,14.6-8.3Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M96.8,286.6l-6.3,3.6.5.8,6.2-3.6Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M99.4,288l-6.3,3.6.5.8,6.2-3.6Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M101.9,289.5l-6.3,3.6.5.8,6.2-3.6Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M115.6,303.4l-14.5,8.3.4.8,14.6-8.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-2"
      d="M181,241.7c-5.5,5.4-9.9,5.8-15.2,8.3s-5.9,5.7-5.9,5.7L145.4,254v-7.1a49,49,0,0,1,8.4-6.9c4.4-2.6,14.8-11,17.1-13.6a8.8,8.8,0,0,1,4.2-2.6c2.3-.5,5.3-.2,7.8,3.9C188.1,236.1,181,241.7,181,241.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M160.5,256.5h-.6l-15.1-1.8v-8l.2-.2a47.2,47.2,0,0,1,8.6-7c4.3-2.6,14.7-10.9,16.9-13.4a9.3,9.3,0,0,1,4.6-2.8c2.4-.6,5.8-.3,8.6,4.2,5.2,8.4-1.5,14.3-2,14.8-4.1,4.1-7.6,5.4-11.3,6.7l-4.1,1.6c-4.8,2.2-5.4,5.1-5.5,5.2Zm-14.3-3.1,13.3,1.6c.4-1.2,1.9-3.7,6.1-5.6a36.9,36.9,0,0,1,4.2-1.7,26.5,26.5,0,0,0,10.8-6.4h.1c.3-.2,6.5-5.3,1.8-13-1.9-3.1-4.3-4.3-7.1-3.6a6.9,6.9,0,0,0-3.8,2.4c-2.3,2.6-12.9,11.1-17.3,13.7a47.3,47.3,0,0,0-8.1,6.5Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M150.6,245.7a8.2,8.2,0,0,0-7,1.7c-2.5,1.8-3.6,4.5-5.3,7.4s-2.8,5-2.8,5a2.1,2.1,0,0,0-1.2,1.3s-1.2-.5-1.5-1.3.2-3.6.2-3.6.7-3.2-.5-4.1-2.4-.4-3.2,1.5a19.1,19.1,0,0,0-.9,5.3c-.6-1.7-1.5-2.9-3.1-2.8s-1.9,1-1.8,2.6,3,6.7,3,6.7,3.5,4.7,5.2,5.3a53.5,53.5,0,0,0,6.5,1.5l-1.9,1.9c-.3.2-.3.8-.6.9s-6.1,0-7.1.6-2.6,1.5-1.8,4.2a58.5,58.5,0,0,0-6.2,2.8c-1.1.6-1.1,1.6-.2,3.1s1.3.9,5.8-.1,10.6-2.9,10.6-2.9l4.1-2.7a108.9,108.9,0,0,0,10.9-5.1s2.2-1.2,4.8-7.4l.4-.9a21.9,21.9,0,0,0,2.3-5.9c1.1-4.3.7-10.1-1.7-12.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M122.8,287a4.5,4.5,0,0,1-2.6-.5H120a3.6,3.6,0,0,1-.7-2.8,1.9,1.9,0,0,1,1.2-1.3,60.5,60.5,0,0,1,5.7-2.6c-.6-2.6,1-3.6,2.1-4.3h.1c.8-.5,2.9-.6,5.7-.7h1.5l.4-.6,1-1-5.4-1.3c-1.9-.7-5.2-5.1-5.6-5.6s-3.1-5.3-3.2-7.1-.2-3.2,2.4-3.4a3,3,0,0,1,2.7,1.2,14.5,14.5,0,0,1,.8-3.3,3.5,3.5,0,0,1,2.1-2.3,2.6,2.6,0,0,1,2.2.4c1.6,1.1,1,4.2.8,4.8a9.5,9.5,0,0,0-.2,3.2l.5.6a3,3,0,0,1,1-.9l2.7-4.8.9-1.6c1.3-2.3,2.5-4.5,4.6-6.1a8.9,8.9,0,0,1,7.5-1.8l-.3,1.6a7.4,7.4,0,0,0-6.4,1.5c-1.9,1.4-3,3.4-4.2,5.6l-.9,1.6a53,53,0,0,0-2.7,5v.2h-.3a1.1,1.1,0,0,0-.7.8l-.2.8-.7-.3a3.5,3.5,0,0,1-1.9-1.7c-.4-1,0-3.3.2-4s.3-3-.2-3.4a1.1,1.1,0,0,0-1-.3q-.6.1-1.2,1.5a16.6,16.6,0,0,0-.9,5v.6h-1.2l-.2-.6c-.7-1.7-1.4-2.4-2.4-2.3s-1.2.3-1.1,1.9,1.8,4.5,2.9,6.4,3.8,4.6,4.9,5a48.9,48.9,0,0,0,6.4,1.5h.5l.2.9-.3.3-1.9,1.9a.3.3,0,0,1-.1.2,1.2,1.2,0,0,1-1,.9h-1.7c-1.4,0-4.5.1-5,.5h-.1c-1.1.7-2,1.2-1.3,3.3l.2.7-.7.2a62.5,62.5,0,0,0-6.1,2.7c-.4.2-.4.4-.5.5s0,.7.5,1.5,1.8.5,5.2-.2,9.6-2.6,10.4-2.8l4.1-2.7a103.8,103.8,0,0,0,10.8-5s2.1-1.3,4.5-7.1l.5-1a20.4,20.4,0,0,0,2.2-5.7c1-4,.7-9.6-1.6-12l1-1c2.8,2.9,3,8.9,1.9,13.3a22.5,22.5,0,0,1-2.3,6.1l-.4.8c-2.6,6.3-4.8,7.6-5.1,7.8-4.2,2.3-10.2,4.8-10.9,5.1l-4.2,2.8c-.1,0-6.2,1.9-10.6,2.9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M135.1,281.4l-8.2-.7v-1.4l8.1.7,5.9-.5v1.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M136,266.3a25,25,0,0,0-4.7-1.9H131l-3.3-5.2,1.2-.8L132,263a22.4,22.4,0,0,1,4.8,2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M135.9,275.9l-.3-1.4a22.6,22.6,0,0,0,5-1.5h.2a11.2,11.2,0,0,1,4.1-1.6l.2,1.4a11.9,11.9,0,0,0-3.6,1.4h-.2A22.6,22.6,0,0,1,135.9,275.9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M141.4,264.9a8,8,0,0,0-5.9-4.4v-1.4a9,9,0,0,1,7,5.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M147.3,251.2h-1.4c0-2.2,1.4-6.4,6.2-6.4v1.4C147.4,246.2,147.3,251,147.3,251.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M120.2,285.1a8.5,8.5,0,0,0,4.3-.2c.2,0,.4,0,.5.2l.4.9-3.8.2-.9-.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M126.5,278.7l4.1.2a.4.4,0,0,1,.4.4v1l-4.2-.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M123.5,257.6a5.6,5.6,0,0,0,1.3.8l.9,2.9c.5,1.6-.9.9-.9.9l-1-3.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M130.1,252.4a3.8,3.8,0,0,0,1.3,1.4s-.9,3.1-1.8,2.8-.5-2.1-.5-2.1Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M131.4,265.4l-1-1a4.1,4.1,0,0,0,.5-.9l1.3.4A5.6,5.6,0,0,1,131.4,265.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M151,272.9a3.7,3.7,0,0,1-.7-1.6h.5a3.5,3.5,0,0,0,.6,1.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-2" d="M124.3,259.4l-1-.4.2-.4.9.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-2" d="M130.4,254.4l-.7-.8.4-.3.7.7Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M172.8,245l-.5-1.3a17.3,17.3,0,0,0,6.5-4.8l1.1.9A18.8,18.8,0,0,1,172.8,245Z"
      transform="translate(-0.6 -13.7)"
    />
    <g id="thumb2">
      <path
        class="cls-1"
        d="M149.8,274.6h-.1c-.1,0-2.3-.1-2.6-4.1s2.4-6.2,3.2-6.9a6.4,6.4,0,0,1,.8-2.6c.5-1,.4-3.9.2-5.5l1.4-.2c.1.5.5,4.6-.3,6.3a5.7,5.7,0,0,0-.7,2.3v.3l-.2.2s-3.2,3-3,6,.8,2.7,1.1,2.8a5.1,5.1,0,0,0,1.6-1.3,37.3,37.3,0,0,1,5.4-5.6l.9,1.1a35.1,35.1,0,0,0-5.2,5.3,6.3,6.3,0,0,1-2.4,1.9Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M150.8,273.5a2.2,2.2,0,0,1-1.1-2.1,4.5,4.5,0,0,1,2.4-2.3c1.6-.5,1.7.9,1.7.9l-2.5,3.3Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M157.6,267.4l-1.3-.5h0a2.9,2.9,0,0,0-1-.7l.6-1.3C156.9,265.5,158,266.4,157.6,267.4Z"
        transform="translate(-0.6 -13.7)"
      />
    </g>
    <path
      class="cls-2"
      d="M125.2,185.8c-1-3.5-3.2-5.3-5-5.6a6.3,6.3,0,0,0-3.8.6l-1,.5c-11,5.6-9.7,5.5-21.1,10.1l-8,2.9s-15.9,1.8-17.3,2.9-1.5,1.8-1.5,1.8l-7.3,8.4s-3.2,6.5-4.6,9.9a14.5,14.5,0,0,0-1.1,6.3,5.2,5.2,0,0,0,2.3.9s-.2,1.1-.4,2.5a17.2,17.2,0,0,0,0,2.5,3.1,3.1,0,0,0,3,.4v.6c.9,1.2,2.1.6,3,0a13.6,13.6,0,0,0,2.3-3.4c.1-.1.3-.2.4,0l.8.9c1.8.5,3.3-.8,4.7-2.3l4.2-4.6s10.2-6,12.7-7.1l5.6-2.9a43.8,43.8,0,0,0,6.8-5.3c1.1-.9,7-2.5,10.5-3.4a76.9,76.9,0,0,0,9.1-3.4l3.8-2.3C125.6,194.8,127,192.2,125.2,185.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M60.6,232.1a2.3,2.3,0,0,1-1.9-1h-.1a3.5,3.5,0,0,1-2.8-.8l-.2-.2v-.3a20.1,20.1,0,0,1,0-2.7c.1-.8.2-1.4.3-1.9a3.9,3.9,0,0,1-1.9-1l-.2-.2v-.3a15.6,15.6,0,0,1,1.1-6.6c1.4-3.4,4.5-9.7,4.6-10h.1l7.2-8.3a4.1,4.1,0,0,1,1.7-2c1.5-1.1,13.7-2.6,17.6-3.1l7.9-2.8a113.9,113.9,0,0,0,13.9-6.3l7.2-3.7,1-.5a7.7,7.7,0,0,1,4.2-.6c2,.3,4.5,2.3,5.6,6.1,2,7,.1,9.7-2.2,11.6l-3.9,2.4a64.3,64.3,0,0,1-9.2,3.5c-2.3.6-9.2,2.4-10.2,3.2a41.4,41.4,0,0,1-7,5.4l-5.7,2.9c-2.4,1-11.6,6.5-12.6,7.1l-4.2,4.6c-1.2,1.4-3.1,3.2-5.4,2.5h-.2l-.5-.5a14.7,14.7,0,0,1-2.2,3.1A4.4,4.4,0,0,1,60.6,232.1Zm-.6-1.7c.3.3.7.5,1.9-.3a15.4,15.4,0,0,0,2.1-3.2c.1-.3.4-.4.7-.5a1.1,1.1,0,0,1,.8.3l.6.7c1.1.2,2.3-.5,3.8-2.1l4.2-4.7h.2c.4-.2,10.2-6.1,12.8-7.2l5.6-2.9a36.5,36.5,0,0,0,6.7-5.2c1.2-1,5.9-2.3,10.8-3.5a74,74,0,0,0,8.9-3.4l3.7-2.2c1.8-1.5,3.6-3.6,1.7-10.2-.9-3.2-2.9-4.8-4.4-5.1a5.8,5.8,0,0,0-3.4.5l-1,.5-7.1,3.7a122.5,122.5,0,0,1-14,6.4l-8.2,2.9c-7.7.9-16.1,2.2-17,2.8s-1.2,1.4-1.2,1.4v.2h-.1l-7.3,8.4c-.4.8-3.3,6.6-4.5,9.8a16.5,16.5,0,0,0-1.1,5.7,5,5,0,0,0,1.7.6h.7v.7s-.2,1-.4,2.4a7.2,7.2,0,0,0,0,2.1,2.4,2.4,0,0,0,2,.2l1-.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M56.9,225.3l-.2-1.4v0a2.2,2.2,0,0,0,1.4-1.4c.6-1.6,3.2-7.1,3.3-7.3h.1l2.4-3.2s2.9-2.3,3.6-4.2a7.3,7.3,0,0,0,.6-2.9l1.4-.2a9.4,9.4,0,0,1-.7,3.6c-.8,2.1-3.5,4.4-4,4.8l-2.2,2.9c-.3.6-2.7,5.7-3.2,7.2A3.8,3.8,0,0,1,56.9,225.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M59.6,230.7l-.5-1.3.3.6-.3-.6a4.1,4.1,0,0,0,1.5-2.4c.7-2.4,4.5-9.1,4.6-9.4h.2a17.5,17.5,0,0,0,3.2-3.2,4.7,4.7,0,0,0,.9-2.8l1.4-.2a5.8,5.8,0,0,1-1.1,3.7,15,15,0,0,1-3.4,3.4c-.5.9-3.8,6.8-4.4,9S59.7,230.7,59.6,230.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M65.2,227.7l-1.1-.9,3.7-4.7a35.9,35.9,0,0,0,4-4c1-1.2,1.4-2.6.9-3.3l1.2-.8c.8,1.3.5,3.1-1,4.9a37.6,37.6,0,0,1-4.2,4.1Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M80.7,209.6l-.5-2a7.3,7.3,0,0,0-1.9-2.8,6.4,6.4,0,0,0-3.9-2l-2-.3.2-1.4,2,.3a8.2,8.2,0,0,1,4.8,2.4,8.7,8.7,0,0,1,2.2,3.4l.6,2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M79.9,211.5c-1.3-1.5-3.3-2.8-3.9-2.6l-.4-1.3c1.9-.6,4.8,2.4,5.4,3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M100,206.6l-1.2-.8a13.2,13.2,0,0,0,2-5.6h1.4A13.8,13.8,0,0,1,100,206.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M100.6,199.1a2.8,2.8,0,0,0-.9-1.9l.8-1.2a4,4,0,0,1,1.5,2.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M66.5,218H65.1a7.8,7.8,0,0,0-.3-1.9l1.3-.4A4.8,4.8,0,0,1,66.5,218Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M64.5,213.1H63.1a7.8,7.8,0,0,0-.3-1.9l1.3-.4A4.5,4.5,0,0,1,64.5,213.1Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M68.5,223.3l-1.1-.9c.3-.3.2-1.4,0-2.1l1.3-.4C68.9,220.4,69.3,222.3,68.5,223.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M54.9,219.7l.7.3a.5.5,0,0,1,.3.7,15.3,15.3,0,0,0-.5,3.3l-1-.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M56.4,226l.8.3a.7.7,0,0,1,.4.6c-.1.6-.1,1.7-.2,3.1l-1-.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M122.6,188c-.5-4-2.2-4.3-2.2-4.3v-1.4c.3,0,2.8.4,3.4,5.5Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M48.1,233.5,38.5,239l-10.7-6.3,9.6-5.5Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M38.5,239.7l-11.9-7,10.8-6.1,11.9,7Zm-9.5-7,9.5,5.5,8.4-4.8-9.5-5.5Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M43.8,227.2l10.7,6.2-9.6,5.5-10.7-6.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M44.9,239.6l-11-6.5.6-1,10.4,6.1,8.4-4.8-9.8-5.7.6-1.1,11.6,6.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M151.2,262.4a2.9,2.9,0,0,0-1.3-2.2l-34.2-20h-.4c-3.1.7-5.4-2.8-5.6-3.2l-.5-.7L75,216.4a1,1,0,0,0-.9-.1L21.5,246.7l37.6,24,38.2,23.4,53.5-30.8A1,1,0,0,0,151.2,262.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M97.1,294.6h-.2L58.7,271.1,20.5,246.6l53.3-30.8a1.4,1.4,0,0,1,1.4.1L109.5,236l.5.8c.2.4,2.4,3.6,5.1,3h.6l34.4,20.1a3.2,3.2,0,0,1,1.5,2.6,1.3,1.3,0,0,1-.8,1.3ZM22.3,246.7l37,23.6,37.9,23.3,53.4-30.7a.4.4,0,0,0,.2-.4,2.4,2.4,0,0,0-1-1.8l-34.1-19.9h-.2c-3.4.8-5.8-2.9-6.1-3.4l-.4-.6-34.1-20h-.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M95.5,293.1l1.6,1,53.5-30.8c.3-.1.5-.4.5-.9s.2-.8-.5-1.2L96.9,292.1Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M112.1,237.2c-1.6-3.3-6.8-12.9-15.3-17.8-11.3-6.5-11.8-1.8-20.1-7.7l-51,29.2,35,26.1,51-29.2C112.1,238,112.4,237.7,112.1,237.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M60.7,267.8l-.3-.3L25.2,241.2v-.7h.2L76.8,211l.3.3a17.1,17.1,0,0,0,8.6,3.5c2.7.4,5.7.8,11.4,4.2,8.5,4.9,13.7,14.3,15.5,18a1.2,1.2,0,0,1-.1,1.3c-.2.1-.4.3-.7.2ZM26.8,241l34,25.3,50.7-29c-1.5-3.1-6.6-12.6-14.9-17.3-5.6-3.2-8.5-3.6-11-4a17.9,17.9,0,0,1-8.9-3.5Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M80.2,213.9a26.9,26.9,0,0,1-3.6-2.2l-51,29.2,8.7,6.5.9-.5-6.1-3.5Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M34.4,248.2l-9.3-6.9v-.7l.3-.2L76.8,211l.3.2a23.1,23.1,0,0,0,3.5,2.1l-.5,1.1a32.4,32.4,0,0,1-3.3-2L27,241l2.6,2,7.1,4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M24.5,245.8,60.8,267c.4.2.6-.2.4-.6-1.6-3.3-6.8-12.9-15.3-17.8-11.3-6.5-11.8-1.8-20.1-7.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M61,267.7h-.5L23.9,246.2l1.4-5.7.6-.2.3.2a17.1,17.1,0,0,0,8.7,3.6c2.7.4,5.7.8,11.4,4.2,8.5,4.9,13.7,14.3,15.5,18a1.2,1.2,0,0,1-.1,1.3ZM25.2,245.5,60.3,266c-1.7-3.5-6.8-12.3-14.7-16.9-5.6-3.2-8.5-3.6-11-4a18.1,18.1,0,0,1-8.5-3.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M59.4,266.7C49.3,249,39.3,248,35,247.6s-9.8-4.5-10-4.6l.6-.7s4.2,3.9,9.5,4.4,14.8,1.4,25.1,19.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M56.9,265.2c-8.1-13.3-15.2-14.4-20.4-15.2l-2.1-.4a20.3,20.3,0,0,1-9.6-5.6l.7-.6s4.1,4.3,9.1,5.4l2.1.4c5.4.8,12.7,2,21.1,15.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M53.8,263.4c-3.3-5.4-7.3-8.9-11.6-10.2s-9.8-2.4-9.9-2.4l.2-.9c.1,0,5.6,1.2,10,2.4s8.8,5,12.2,10.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M50.5,261.5a18.8,18.8,0,0,0-5.3-5,23.3,23.3,0,0,0-7.7-2.6V253a23,23,0,0,1,8.1,2.7,19.5,19.5,0,0,1,5.6,5.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M59.1,273.4a16.7,16.7,0,0,1-4.3-4L21.7,250a2.9,2.9,0,0,1-1.3-2.2c0-.8.6-1.2,1.3-.7l34.2,20,.5.7c.2.4,2.6,3.9,5.6,3.2h.4l34.2,20a2.9,2.9,0,0,1,1.3,2.2c0,.8-.6,1.2-1.3.7L63.4,274.4A6,6,0,0,1,59.1,273.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M97.2,294.7a1.6,1.6,0,0,1-.9-.3L63.2,275.1a6.9,6.9,0,0,1-4.5-1.1,16.2,16.2,0,0,1-4.4-4.1l-33-19.3a3.4,3.4,0,0,1-1.6-2.8,1.7,1.7,0,0,1,.7-1.4,1.6,1.6,0,0,1,1.5.1l34.4,20.1.5.9c.1.1,2.3,3.5,5,2.9h.8l34.2,20a3.4,3.4,0,0,1,1.6,2.8,1.7,1.7,0,0,1-.7,1.4ZM63.5,273.8,97,293.4h.3a.4.4,0,0,0,.1-.3,2.3,2.3,0,0,0-1-1.7l-34-19.9h-.2c-3.5.8-6-3-6.3-3.4l-.4-.6-34.1-20h-.3a.4.4,0,0,0-.1.3,2.3,2.3,0,0,0,1,1.7l33.2,19.4h.1a12.8,12.8,0,0,0,4.1,3.9,6,6,0,0,0,4,.9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-3" d="M61.3,266.5a7,7,0,0,1,2.9-3.7Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M61.9,266.7l-1.2-.3a7.4,7.4,0,0,1,3.2-4l.6,1.1A6.1,6.1,0,0,0,61.9,266.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M147.8,253.2l-1.2-.6c-7.2-3.8-8.2-8.9-18.9-15.2-8.4-5-13.6-1.6-15.3-.2h-.3l-48.4,26s-2.4,1.8-2.3,3.8l31.8,14.7,4.7,7,51-29.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M98.1,289.4h-.5V289L93,282.2,61.2,267.5l-.3-.2V267c-.1-2.2,2.2-4.1,2.5-4.3h.1l48.6-26.1h.2c2.1-1.7,7.4-4.6,15.8.3a49.3,49.3,0,0,1,11.3,9.1c2.3,2.3,4.2,4.4,7.5,6.1l1.5.7v.3l1.1,6.4v.4l-.3.2Zm-4.4-8.1h.1l4.3,6.5,50.1-28.7-1-5.6-.9-.4c-3.5-1.8-5.5-3.9-7.9-6.3a49.9,49.9,0,0,0-11.1-8.9c-8-4.7-12.8-1.7-14.6-.2l-.2.2h-.3L64,263.8a5.4,5.4,0,0,0-2,2.9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M93.3,280.7l-.2,1.2h.1l.7,1,2.8-.4,51-29.2-3.5-2.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M93.5,283.6l-.8-1.2-.3-.2.3-1.7v-.2l.5.4h.6l-.2.9.4.6,2.4-.3,49.9-28.6-2.6-1.7.3-.5-.4-.5h.7l3.8,2.3v.8h-.3L97,283.1h-.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M96.8,282.5l51-29.2,1.1,6.3-51,29.2Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M98,289.4l-.6-.3-1.3-7,.4-.3,51.2-29.4.5.2v.3l1.2,6.5v.4l-.3.2Zm-.5-6.6.9,5,49.9-28.6-.9-5.1Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-3" d="M98.5,285.4l-.2-.4,48.8-27.8.3.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-3" d="M98.7,287.4l-.3-.4,48.9-27.9.2.5Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-3" d="M98.1,283.6l-.2-.4,48.8-27.8.3.4Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-2"
      d="M44.9,252.2l-3.5,2a5.1,5.1,0,0,0-2.2,2.6,6.3,6.3,0,0,1-3,3.4l-7.1,4.1c-.2.1-.1.3.1.3h3.5a.2.2,0,0,1,.2.2l.4,2.3a.2.2,0,0,0,.3.1l7.2-4a6.4,6.4,0,0,0,3.1-3.6v-.2a5.1,5.1,0,0,1,2.3-2.7l2.9-1.6c.1,0,.1-.1,0-.2l-.8-.6-2.7-1.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M33.4,267.8h-.3a.7.7,0,0,1-.4-.6l-.4-2H29.2c-.4,0-.7-.2-.7-.6a.9.9,0,0,1,.4-.9l7.1-4.1a5.8,5.8,0,0,0,2.7-3.1,5.9,5.9,0,0,1,2.5-2.9l3.8-2.1,1,.6a22,22,0,0,1,2.8,1.8l.8.6a.7.7,0,0,1,.3.6.8.8,0,0,1-.4.6l-2.9,1.6a3.8,3.8,0,0,0-2,2.3v.2a6.9,6.9,0,0,1-3.4,3.9l-7.1,4A.8.8,0,0,1,33.4,267.8ZM30.7,264h1.9a.8.8,0,0,1,.8.7l.3,1.7,6.6-3.7a6.7,6.7,0,0,0,2.9-3.3v-.2a5.5,5.5,0,0,1,2.6-3l2.2-1.2h-.2a24.6,24.6,0,0,0-2.7-1.7l-.4-.3-3.2,1.8a4.1,4.1,0,0,0-1.9,2.2,7.6,7.6,0,0,1-3.3,3.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M38.3,264.2l-1.2-.7.6-1,1.2.7Zm-2-1.2-1.6-1,.6-1,1.6,1Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M58.3,265.2l-2.6,1.5.5.7,2.5-1.4Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M64.5,269.2l-2.3,1.4.4.7L65,270Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M57.9,266a7.5,7.5,0,0,0,6.5,3.8l.8-.5-6.7-3.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M140.9,248.5c-3.3-3.1-6.1-6.8-13.3-11.1s-13.6-1.6-15.3-.2H112l-48.4,26s-2.4,1.8-2.3,3.8l20.9,9.7,3.4-3.2s4.7,3.8,10,.8S128.4,255.6,140.9,248.5Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M82.5,277.4l-21.6-10V267c-.2-2.3,2.4-4.2,2.5-4.3h.1l48.6-26.1h.2c2.1-1.7,7.4-4.6,15.8.3a49.3,49.3,0,0,1,11.3,9.1c.7.7,1.3,1.4,2,2l.6.6L96.2,274.8a9.7,9.7,0,0,1-10.2-.6ZM62.1,266.6,82.3,276l3.5-3.2.4.3c.2.1,4.5,3.5,9.3.8l44.4-25.5-1.5-1.5a49.9,49.9,0,0,0-11.1-8.9c-8-4.7-12.8-1.7-14.6-.2l-.2.2h-.3L64,263.8A4.7,4.7,0,0,0,62.1,266.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M125.3,233.5c-4.8-2.1-8.1-1.2-10.2.2L65.2,262.3l-1,.5h0l2.6-1.1a11.2,11.2,0,0,1,7.5,1c9.8,4.2,14.7,13.2,21.4,11.7l50.9-29.2C140.1,246.7,135.1,237.7,125.3,233.5Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M94.2,275.2c-3.4,0-6.5-2.5-10-5.3a44.1,44.1,0,0,0-10.1-6.6,11.5,11.5,0,0,0-7.1-1l-2.5,1.1-.6-1.1,1-.6,49.9-28.6c2-1.3,5.5-2.5,10.7-.2a45.7,45.7,0,0,1,10.4,6.8c3.9,3.2,7,5.7,10.6,4.8h.5l.4,1-.5.3L96,274.8h-.3A3.3,3.3,0,0,1,94.2,275.2ZM69,260.9a13.7,13.7,0,0,1,5.6,1.3A45.7,45.7,0,0,1,85,269c3.9,3.1,7,5.6,10.6,4.8l48.7-27.9c-3.1-.4-5.9-2.7-9.1-5.2a44.1,44.1,0,0,0-10.1-6.6c-3.8-1.7-7.1-1.6-9.6.1L69,260.9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M124.4,233.1c-4.4-1.6-7.4-.8-9.3.6L65.2,262.3l-1,.5h0l2.6-1.1a11.2,11.2,0,0,1,7.5,1,34.5,34.5,0,0,1,7.3,4.4,34.5,34.5,0,0,0-7.3-4.4l-1.1-.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M81.6,267.8l-.4-.2a36.8,36.8,0,0,0-7.2-4.3,11.5,11.5,0,0,0-7.1-1l-2.5,1.1-.6-1.1,1-.6,49.9-28.6c1.8-1.2,5-2.4,9.8-.6l-.4,1.1c-3.5-1.3-6.4-1.1-8.8.5L68.8,260.8a12.9,12.9,0,0,1,4.6.9l1.2.5a45,45,0,0,1,7.4,4.4l.7.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <g id="booklines">
      <path
        class="cls-1"
        d="M59.6,251.6l-3.3-3.2A31.5,31.5,0,0,0,40.1,241v-.9a31.3,31.3,0,0,1,16.7,7.6l3.3,3.3Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M62.4,249.8q-1.5-1.7-3.3-3.3a31.1,31.1,0,0,0-16.2-7.4v-.9a31.3,31.3,0,0,1,16.7,7.6c1.2,1.1,2.4,2.2,3.4,3.3Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M65.6,248.2,62,244.7a31.5,31.5,0,0,0-16.2-7.4v-.9A31.3,31.3,0,0,1,62.6,244l3.6,3.6Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M69.4,246.6l-3.7-3.7a31.5,31.5,0,0,0-16.2-7.4v-.9a31.3,31.3,0,0,1,16.7,7.6l3.8,3.8Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M76.9,251.1s-1.3-3.7-8.3-10.1a31.1,31.1,0,0,0-16.2-7.4v-.9a31.3,31.3,0,0,1,16.7,7.6c7.2,6.6,8.5,10.3,8.5,10.5Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M80.4,249.2s-1.3-3.7-8.3-10.1a31.5,31.5,0,0,0-16.2-7.4v-.9a31.3,31.3,0,0,1,16.7,7.6c7.2,6.6,8.5,10.3,8.5,10.5Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M83.4,247.4s-1.3-3.7-8.3-10.1a31.1,31.1,0,0,0-16.2-7.4V229a31.3,31.3,0,0,1,16.7,7.6c7.2,6.6,8.5,10.3,8.5,10.5Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M87,245.6s-1.3-3.7-8.3-10.1a31.5,31.5,0,0,0-16.2-7.4v-.9a31.3,31.3,0,0,1,16.7,7.6c7.2,6.6,8.5,10.3,8.5,10.5Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M89.9,243.7s-1.3-3.7-8.3-10.1a24,24,0,0,0-3.9-3l.5-.8a22.1,22.1,0,0,1,4.1,3.1c7.2,6.6,8.5,10.3,8.5,10.5Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M92.9,241.9s-1.3-3.7-8.3-10.1a29.7,29.7,0,0,0-3.5-2.7l.5-.8a32.7,32.7,0,0,1,3.7,2.8c7.2,6.6,8.5,10.3,8.5,10.5Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M95.9,240.1s-1.3-3.7-8.3-10.1a34.4,34.4,0,0,0-3.6-2.8l.5-.8a26.3,26.3,0,0,1,3.7,2.9c7.2,6.6,8.5,10.3,8.5,10.5Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M99.5,238.3s-1.3-3.7-8.3-10.1a21.8,21.8,0,0,0-3.4-2.6l.5-.8a19.1,19.1,0,0,1,3.5,2.7c7.2,6.6,8.5,10.3,8.5,10.5Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M102.4,236.4s-1.3-3.7-8.3-10.1a24.2,24.2,0,0,0-3.6-2.7l.5-.8a35.8,35.8,0,0,1,3.7,2.8c7.2,6.6,8.5,10.3,8.5,10.5Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M96.2,269.4c-2.7,0-6.1-2.7-9.4-5.5a41.1,41.1,0,0,0-3.5-2.7l.5-.8a29.3,29.3,0,0,1,3.6,2.8c3.5,2.9,7.4,6,9.8,5.1l.3.9A2.7,2.7,0,0,1,96.2,269.4Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M99.6,267.5c-2.7,0-6.1-2.7-9.4-5.5a32.7,32.7,0,0,0-3.7-2.8l.5-.8a32.7,32.7,0,0,1,3.7,2.8c3.5,2.9,7.4,6,9.8,5.1l.3.9A2.1,2.1,0,0,1,99.6,267.5Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M103,265.5c-2.7,0-6.1-2.7-9.4-5.5a38.5,38.5,0,0,0-3.4-2.6l.5-.8a41.1,41.1,0,0,1,3.5,2.7c3.5,2.9,7.4,6,9.8,5.1l.3.9A2.7,2.7,0,0,1,103,265.5Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M106.2,263.5c-2.7,0-6.1-2.7-9.4-5.5-5.2-4.4-9.1-5.6-9.1-5.6l.3-.9c.2,0,4.1,1.2,9.4,5.8,3.5,2.9,7.4,6,9.8,5.1l.3.9Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M109.7,261.5c-2.7,0-6.1-2.7-9.4-5.5-5.2-4.4-9.1-5.6-9.1-5.6l.3-.9c.2,0,4.1,1.2,9.4,5.8,3.5,2.9,7.4,6,9.8,5.1l.3.9Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M113.2,259.5c-2.7,0-6.1-2.7-9.4-5.5-5.2-4.4-9.1-5.6-9.1-5.6l.3-.9c.2,0,4.1,1.2,9.4,5.8,3.5,2.9,7.4,6,9.8,5.1l.3.9A2.7,2.7,0,0,1,113.2,259.5Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M107.2,252.1c-5.2-4.4-9.1-5.6-9.1-5.6l.3-.9c.2,0,4.1,1.2,9.4,5.8Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M113.8,247.9c-5.2-4.4-9.1-5.6-9.1-5.6l.3-.9c.2,0,4.1,1.2,9.4,5.8Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M117.2,246c-5.2-4.4-9.1-5.6-9.1-5.6l.3-.9c.2,0,4.1,1.2,9.4,5.8Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M120.6,244c-5.2-4.4-9.1-5.6-9.1-5.6l.3-.9c.2,0,4.1,1.2,9.4,5.8Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M123.8,241.9c-5.2-4.4-9.1-5.6-9.1-5.6l.3-.9c.2,0,4.1,1.2,9.4,5.8Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M110.5,250c-5.2-4.4-9.1-5.6-9.1-5.6l.3-.9c.2,0,4.1,1.2,9.4,5.8Z"
        transform="translate(-0.6 -13.7)"
      />
    </g>
    <path
      class="cls-3"
      d="M97.9,288.8,61.7,267.6a.9.9,0,0,1-.4-1.1c1.6-1.4,6.9-4.9,15.4.1,11.3,6.7,11.7,12,20.1,15.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M98,289.5l-.3-.2L61.5,268.1a1.4,1.4,0,0,1-.7-1.2,1.1,1.1,0,0,1,.3-.8c1.5-1.3,7.1-5.2,16.1.1a49.3,49.3,0,0,1,11.3,9.1c2.5,2.6,4.7,4.8,8.7,6.6h.2v.3l1.2,6.8ZM61.9,266.9a.3.3,0,0,0,.1.2l35.1,20.5-.9-4.7c-4.1-1.9-6.3-4.2-8.8-6.8a49.9,49.9,0,0,0-11.1-8.9C68.6,262.5,63.7,265.3,61.9,266.9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M97.1,285.1c-.2,0-4.5-1.1-10-7s-14.2-15.3-24.2-9.6l-.5-.8c10.6-6.1,21,5,25.4,9.7s9.4,6.7,9.5,6.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M97.4,286.5c-.2,0-4.4-.5-9.7-5.6l-2.1-2.1c-5.2-5.2-12.2-12.4-20.3-8.8l-.4-.8c8.6-3.9,16,3.5,21.3,9l2.1,2.1c5,4.9,9.1,5.4,9.1,5.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M89.8,284.5c-.1-.1-5.6-5.4-9.9-9.2s-8.3-5-11.4-3.5l-.4-.8c3.5-1.7,7.9-.4,12.5,3.6s9.8,9.2,9.9,9.2Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M84.6,281.5s-4.5-4.7-7.8-6.5-5.1-1.2-5.1-1.2l-.3-.9c.1,0,2.3-.7,5.8,1.3s7.8,6.5,8,6.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M129.7,267.5l-9.5,5.4-6.8-3.9,9.5-5.5Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M120.2,273.6l-7.9-4.6,10.7-6.2,8,4.7Zm-5.6-4.6,5.5,3.2,8.4-4.8-5.6-3.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-3" d="M121.1,269l-3.8-2.2,9.5-5.6,3.8,2.3Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M120.8,269.5l-4.7-2.7,10.7-6.3,4.1,2.5-.6,1-3.5-2-8.3,4.8,2.9,1.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <g id="thumb1">
      <path
        class="cls-2"
        d="M82.8,201.9a3.2,3.2,0,0,1,.6,3.5,60.7,60.7,0,0,1-5,9.8c-1.6,2.5-3,4.9-2.1,7a3.3,3.3,0,0,0,4.3,1.6,6.2,6.2,0,0,0,2.5-2.2,51.2,51.2,0,0,0,4.5-7.6,18.9,18.9,0,0,1,1.9-3c.9-1,1.3-2,2.5-2.5a11,11,0,0,0,4.2-2.9Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M79.3,224.8a3.2,3.2,0,0,1-1.4-.3,3.6,3.6,0,0,1-2.1-2.1c-1-2.5.6-5.2,2.1-7.7a58.7,58.7,0,0,0,4.9-9.7,2.6,2.6,0,0,0-.4-2.8l.9-1.1a3.7,3.7,0,0,1,.8,4.3,58.8,58.8,0,0,1-5.1,9.9c-1.6,2.6-2.7,4.7-2,6.4a2.3,2.3,0,0,0,1.4,1.3,2.3,2.3,0,0,0,2-.1,6.7,6.7,0,0,0,2.3-1.9,63.9,63.9,0,0,0,4.5-7.5,25.9,25.9,0,0,1,1.9-3.1l.5-.7a5.7,5.7,0,0,1,2.3-2,10.5,10.5,0,0,0,3.9-2.7l1.1.9a12.2,12.2,0,0,1-4.5,3.1,3.3,3.3,0,0,0-1.7,1.6l-.6.7c-.4.5-1.4,2.2-1.8,2.9a70.4,70.4,0,0,1-4.6,7.7,7.8,7.8,0,0,1-2.8,2.4A2.4,2.4,0,0,1,79.3,224.8Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M76.7,222a12,12,0,0,1,1.2-2.8.7.7,0,0,1,.8-.3,7.3,7.3,0,0,1,2.8,1.4.6.6,0,0,1,.2.7,5.7,5.7,0,0,1-1.3,2.4l-1.3.7-1.9-.7Z"
        transform="translate(-0.6 -13.7)"
      />
      <path
        class="cls-1"
        d="M85.1,214.9a17.2,17.2,0,0,0-3.2-1.7l.4-1.3a11.1,11.1,0,0,1,3.7,1.9Z"
        transform="translate(-0.6 -13.7)"
      />
    </g>
    <path
      class="cls-2"
      d="M79.5,223.5h-.1l-.9-.3-.5-.3.2-.4.5.3.6.2a3.7,3.7,0,0,0,.8-1.7h.5A4.1,4.1,0,0,1,79.5,223.5Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M219.6,334.6l-7.6-4.4a10.2,10.2,0,0,1-4.4-5.2,13.1,13.1,0,0,0-6.1-7l-14.4-8.4L211,295.9l14,7.9a13.5,13.5,0,0,1,6.3,7.4v.4a10.1,10.1,0,0,0,4.7,5.5l7,3.9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-1"
      d="M219.6,335.3l-7.9-4.6a10.6,10.6,0,0,1-4.7-5.5,12.7,12.7,0,0,0-5.8-6.7l-15.3-8.9L211,295.2l14.3,8.1a14.3,14.3,0,0,1,6.6,7.7v.4a9.6,9.6,0,0,0,4.4,5.1l7.9,4.5Zm-31.3-25.7,13.5,7.8a13.9,13.9,0,0,1,6.3,7.4,9.6,9.6,0,0,0,4.2,4.9l7.3,4.2L241.8,321l-6.1-3.4a10.6,10.6,0,0,1-5-5.8v-.4a12.9,12.9,0,0,0-6-7l-13.7-7.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-3" d="M215.4,328.7l17.6-10Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M215.6,329.1l-.5-.8,1.6-.9.5.8Zm2.4-1.4-.5-.8,1.6-.9.5.8Zm2.5-1.4-.5-.8,1.6-.9.5.8Zm2.4-1.4-.5-.8,1.6-.9.5.8Zm2.4-1.4-.5-.8,1.6-.9.5.8Zm2.5-1.3-.5-.8,1.6-.9.5.8Zm2.4-1.4-.5-.8,1.6-.9.5.8Zm2.4-1.4-.5-.8.6-.3.5.8Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-3"
      d="M217.1,304.3l-14.7,8.6a1.9,1.9,0,0,1-1.8-.1l-4-2.3c-.5-.3-.6-.8-.1-1l14.7-8.6a1.9,1.9,0,0,1,1.8.1l4,2.3C217.6,303.5,217.6,304,217.1,304.3Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-1" d="M226.1,310.5l-16.8,9.6.4.8,16.9-9.6Z" transform="translate(-0.6 -13.7)" />
    <path class="cls-1" d="M224.4,308.2l-16.8,9.6.4.8,16.9-9.6Z" transform="translate(-0.6 -13.7)" />
    <path
      class="cls-1"
      d="M234.9,319.8,218,329.4l.5.8,16.8-9.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M150.3,120.8v-4.9l5.6,3.2a4.6,4.6,0,0,1,2.1,3.7c0,1.4-.9,1.9-2.1,1.3Zm5.7-4.9-8.4-4.8v19.7l2.8,1.6v-8.2l3.9,2.2,4.2,10.6,3.2,1.9L157.3,128c2,.5,3.5-.9,3.5-3.5S158.7,117.4,156,115.9Zm-23,3.7a12.2,12.2,0,0,1-4.2-4.5,12.1,12.1,0,0,1-1.7-5.9c0-1.9.7-3.3,1.8-3.9a4.1,4.1,0,0,1,4.2.4,12.2,12.2,0,0,1,4.2,4.5,12.1,12.1,0,0,1,1.7,5.9c0,1.9-.7,3.3-1.8,3.9A4.3,4.3,0,0,1,133,119.6Zm.1-17.3c-4.8-2.8-8.7-.4-8.7,5.2s3.9,12.5,8.7,15.3,8.7.4,8.7-5.2S137.9,105.1,133.1,102.3Zm10.5,6.1c-1.1-.7-2.1-.1-2.1,1.2a4.7,4.7,0,0,0,2,3.6c1.1.7,2.1.1,2.1-1.2A4.6,4.6,0,0,0,143.6,108.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M220.1,152.9l-3.4-1.9-4.3,4.8-4.2-9.8-3.4-1.9,6.2,14.3v9l2.8,1.6v-9Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M223.4,158.9a3.8,3.8,0,0,1-1.7-3c0-1.1.8-1.6,1.7-1a3.6,3.6,0,0,1,1.7,3C225.1,158.9,224.4,159.4,223.4,158.9Zm0-4.5c-1.1-.7-2.1-.1-2.1,1.2a4.4,4.4,0,0,0,2.1,3.6c1.1.7,2.1.1,2.1-1.2A4.4,4.4,0,0,0,223.4,154.4Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M222.9,156.3v-.6l.8.5a.9.9,0,0,1,.3.5c0,.2-.1.2-.3.2Zm.8-.6-1.2-.7v2.5l.3.2v-1l.6.3.4,1.3.4.2-.4-1.3c.3.1.5-.1.5-.4A1.3,1.3,0,0,0,223.7,155.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M175.2,127l-11.6-6.7V140l11.6,6.7v-3.3l-8.8-5.1v-4.9l8.4,4.8V135l-8.4-4.9v-4.9l8.8,5.1Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M186.6,133.6l-2.8-1.6v19.6l10.8,6.3v-3.3l-8-4.6Z"
      transform="translate(-0.6 -13.7)"
    />
    <path
      class="cls-2"
      d="M199.7,141.1l-2.8-1.6v19.7l10.8,6.2v-3.2l-8-4.7Z"
      transform="translate(-0.6 -13.7)"
    />
    <path class="cls-2" d="M180.9,130.3l-2.8-1.6v19.7l2.8,1.6Z" transform="translate(-0.6 -13.7)" />
    <path
      id="bookmark-morph"
      class="cls-4"
      d="M206.2,72.3s-6.2-16.8,9.4-30a124.2,124.2,0,0,1,13.2-7.4l-12.6-6.2a31,31,0,0,0-4.5,1h-.3a22.7,22.7,0,0,0-10,5.2c-5.7,5.5-7.1,17-7.1,30.5Z"
      transform="translate(-0.6 -13.7)"
    />
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { mapState } from "vuex";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState([
      "toggleConfig",
      "startConfig",
      "isAnimationDisabled",
      "viewportSize",
    ]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    bookAnim() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-book",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
        })
        .add("book")
        .to(
          "#bookmark",
          {
            duration: 0.5,
            rotation: 6,
            repeat: 3,
            yoyo: true,
            transformOrigin: "0% 100%",
            ease: "sine.inOut",
          },
          "book"
        )
        .to(
          "#thumb1",
          {
            duration: 0.5,
            rotation: 15,
            repeat: 3,
            yoyo: true,
            ease: "sine.inOut",
          },
          "book+=0.25"
        )
        .to(
          "#thumb2",
          {
            duration: 0.5,
            rotation: 15,
            repeat: 3,
            yoyo: true,
            ease: "sine.inOut",
          },
          "book+=0.25"
        )
        .from(
          ".like-boxes",
          {
            duration: 0.5,
            scale: 0,
            opacity: 0,
            rotation: 180,
            transformOrigin: "50% 50%",
            stagger: 0.1,
            ease: "sine",
          },
          "book+=0.5"
        );
    },
  },
  mounted() {
    this.bookAnim();
  },
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: #0e1e25;
}

.cls-2,
.cls-4 {
  fill: #fff;
}

.cls-3 {
  fill: #ffad43;
}

.cls-4 {
  stroke: #000;
  stroke-miterlimit: 10;
  stroke-width: 2px;
}

#bookmark-morph {
  opacity: 0;
}
</style>
